export const translations = {
  en: {
    website: {
      common: {
        loading: 'Loading...',
        error: 'Something went wrong. Please try again later.',
        viewDetails: 'View details',
        visit: 'Visit',
      },
      nav: {
        home: 'Home',
        about: 'About',
        schedule: 'Schedule',
        speakers: 'Speakers',
        opportunities: 'Opportunities',
        sponsors: 'Partners',
        whyOman: 'Why Oman',
        ctaInvest: 'Ready to Invest?',
        ctaGuide: 'Investor Guide',
        languageToggle: 'Language',
        languageAr: 'العربية',
        languageEn: 'English',
      },
      home: {
        date: 'April 27, 2026',
        titleFirst: 'ADVANTAGE  OMAN',
        titleSecond: 'FORUM  2026',
        tagline: 'Shaping the Future of Investment',
        heroTitleFirst: 'Shaping the',
        heroTitleSecond: 'Future of Investment',
        heroSubtitleLine1: 'Join us for insightful discussions, networking opportunities, and firsthand',
        heroSubtitleLine2: "exposure to Oman's most promising investment prospects.",
        countdownLabels: {
          days: 'Days',
          hours: 'Hours',
          minutes: 'Minutes',
          seconds: 'Seconds',
        },
        eventStartedTitle: 'The Event Has Started!',
        eventStartedDescription: 'Join us at the Oman Investment Forum 2026 for exciting opportunities and networking.',
      },
      about: {
        badge: 'Welcome',
        forumTitle: 'TO ADVANTAGE OMAN FORUM',
        loading: 'Loading forum information...',
        error: 'Error loading forum information. Please try again later.',
        attendees: 'Attendees',
        speakers: 'Expert Speakers',
        infrastructure: 'Infrastructure',
        countries: 'Countries',
        statDecisionMakers: 'Decision Makers',
        statGlobalSpeakers: 'Global Speakers',
        statHighValue: 'High Value',
        statCuratedMeetings: 'Curated Meetings',
        description: "Two days of strategic dialogue, sector deep dives, and structured meetings designed to move capital into action.",
        dateBadge: '27-29 April',
        whoShouldAttendTitle: 'Who Should Attend?',
        whoShouldAttendImageAlt: 'Advantage Oman forum — diverse leaders and investors',
        whoShouldAttend: {
          multinational_corporations: 'Multinational Corporations',
          government_decision_makers: 'Government Decision Makers',
          sovereign_wealth_funds: 'Sovereign Wealth Funds',
          private_equity_firms: 'Private Equity Firms',
          strategic_operators: 'Strategic Operators',
          family_offices: 'Family Offices',
        },
        whoShouldAttendDescription: {
          multinational_corporations:
            'Global enterprises exploring expansion into Oman, seeking strategic entry points, partnerships, and access to high-potential sectors within a rapidly evolving economic landscape',
          government_decision_makers:
            'Senior policymakers and public sector leaders driving national development, enabling investment, and shaping the regulatory environment to support sustainable growth.',
          sovereign_wealth_funds:
            "Long-term institutional investors engaging in strategic opportunities aligned with Oman’s vision, focusing on stable returns, diversification, and national value creation.",
          private_equity_firms:
            'Investment leaders identifying scalable opportunities across Oman’s priority sectors, leveraging partnerships to accelerate growth and unlock value.',
          strategic_operators:
            'Established industry players and operators looking to expand operations, optimize performance, and build meaningful collaborations within Oman’s ecosystem.',
          family_offices:
            'Private capital investors seeking diversified, long-term opportunities, co-investments, and direct access to Oman’s emerging sectors and strategic projects.',
        },
      },
      schedule: {
        badge: 'Forum Schedule',
        title: 'Forum Agenda',
        subtitle: 'Explore a carefully curated program of keynotes, panel discussions, and strategic sessions designed to address Oman\'s investment landscape, highlight priority sectors, and foster meaningful connections between global investors and national stakeholders.',
        loading: 'Loading schedule...',
        errorPrefix: 'Error:',
        noData: 'No schedule data found',
        dayLabel: 'Day',
        eventsLabel: 'Events',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationPage: 'Page {current} of {total}',
      },
      faceToFace: {
        title: 'Face to Face Meetings',
        subtitle:
          'World-class infrastructure backed by dedicated industrial, economic, and free zones designed to accelerate growth and maximize investment potential.',
        privateTitle: 'Private Engagement Programme',
        privateBody:
          'A curated series of exclusive engagements designed to connect key stakeholders through tailored discussions and high-value interactions.',
        b2bTitle: 'Structured B2B meetings',
        b2bBody:
          'Pre-arranged meetings that facilitate direct connections between investors, partners, and stakeholders to explore collaboration and business opportunities.',
        govTitle: 'Government Roundtables',
        govBody:
          "Focused discussions with senior government representatives addressing policy, regulation, and strategic initiatives shaping Oman's investment environment.",
        sectorTitle: 'Sector Briefings',
        sectorBody:
          "In-depth sessions providing insights into priority sectors, highlighting opportunities, market trends, and key developments across Oman's economy.",
        imageAlt: 'Face to face meetings at Advantage Oman Forum',
      },
      speakers: {
        badge: 'Our',
        title: 'Our Speakers',
        subtitle: 'Connect with industry leaders and visionaries who are shaping the future of investment in Oman.',
        loading: 'Loading speakers...',
        errorPrefix: 'Error loading speakers:',
        empty: 'No speakers found.',
        details: 'Details',
        about: 'About',
        filterAll: 'All',
        filterGovernment: 'Government',
        filterPrivateSector: 'Private Sector',
        filterInternational: 'International',
        carouselPrev: 'Previous speaker',
        carouselNext: 'Next speaker',
        carouselDot: 'Speaker {n}',
      },
      sponsors: {
        badge: 'Our',
        title: 'Partners',
        subtitle: 'Proudly supported by industry leaders who share our vision for innovation and technological advancement.',
        loading: 'Loading our amazing sponsors...',
        errorPrefix: 'Error loading sponsors:',
        empty: 'No sponsors available yet. Check back soon!',
        visit: 'Visit',
        filterAll: 'All',
        defaultGroup: 'Partners',
      },
      whyOman: {
        badge: 'Investment Destination',
        title: 'Why Oman?',
        subtitle: 'Discover the unique advantages of investing and doing business in the heart of the Middle East',
        keySectorsTitle: 'Key Sectors',
        keySectorsDescription:
          'Explore the vibrant investment opportunities in Oman, spanning essential sectors like technology, renewable energy, logistics, and manufacturing. Join us in discovering how these areas are thriving!',
        exploreAllSectors: 'Explore All Sectors',
        exploreSector: 'Explore Sector',
        sliderPrev: 'Previous sector',
        sliderNext: 'Next sector',
        sliderDot: 'Slide {n}',
        loading: 'Loading investment sectors...',
        errorPrefix: 'Error loading sectors:',
        errorFallback: 'Showing fallback content instead',
        empty: 'No investment sectors available yet. Check back soon!',
        overview: 'Overview',
      },
      whyOmanMap: {
        sectionTitle: 'Infrastructure',
        sectionSubtitle:
          'World-Class Infrastructure Backed by Dedicated Industrial, Economic, and Free Zones Designed to Accelerate Growth and Maximize Investment Potential',
        mapAlt: 'Map of Oman with investment zone markers',
        closeAria: 'Close',
        showDetailsFor: 'Show details for {name}',
        markerLocation: '{name}, map location',
        overviewKpiValue: '$52',
        overviewKpiUnit: 'Billion USD',
        overviewHeadline: 'Invested in Industrial, Economical, and Free Zones',
        overviewSecondaryNumber: '22',
        overviewSecondaryHighlight: 'Strategic Areas',
        tabs: {
          overview: 'Overview',
          industrial: 'Industrial Estates',
          economicFree: 'Economic & Free Zones',
          tech: 'Technology Park',
        },
        types: {
          FZ: 'Free Zones',
          IZ: 'Industrial Zones',
          EZ: 'Economic Zones',
          IT: 'Technology Parks',
        },
        left: {
          industrial: {
            kpiValue: 'Industrial',
            kpiUnit: 'Estates',
            headlineLine1: 'Dedicated industrial clusters',
            headlineLine2: 'supporting manufacturing growth',
            secondaryPrefix: 'IZ',
            secondaryHighlight: 'Locations',
          },
          economicFree: {
            kpiValue: 'Economic',
            kpiUnit: '& Free Zones',
            headlineLine1: 'Investment destinations with',
            headlineLine2: 'incentives and port access',
            secondaryPrefix: '',
            secondaryHighlight: '',
          },
          tech: {
            kpiValue: 'Technology',
            kpiUnit: 'Parks',
            headlineLine1: 'Innovation hubs for ICT,',
            headlineLine2: 'startups, and R&D',
            secondaryPrefix: '',
            secondaryHighlight: '',
          },
        },
        industrialPanel: {
          logoAlt: 'Madayn — Oman industrial estates',
          aboutTitle: 'About',
          aboutBody:
            'The Special Economic Zone at Duqm in Al Wusta is 550 km from Muscat. It is the largest in the Middle East and North Africa, covering 2,000 square kilometers.',
          objectivesTitle: 'Objectives',
          objective1: 'Attract increased foreign investment to Oman',
          objective2: "Boost private sector involvement in the nation's social and economic growth.",
          objective3: 'Promote environmental sustainability in industry',
          objective4: 'Create quality long-term job opportunities for the youth of Oman',
          stats: {
            investors: 'Investors',
            employees: 'Employees',
            investments: 'Investments',
          },
        },
        markers: {
          '1': { name: 'Name 1', highlight: 'Description 1' },
          '2': { name: 'Name 2', highlight: 'Description 2' },
          '3': { name: 'Name 3', highlight: 'Description 3' },
          '4': {
            name: 'Sohar Port Free Zone',
            highlight:
              'Located 220 km from Muscat, Sohar Freezone spans 4,500 hectares and is strategically positioned between Muscat and Dubai. A deep-sea port managing over a million tonnes of cargo weekly, with jetties for the largest vessels.',
          },
          '5': {
            name: 'Khazaen Economic Zone',
            highlight:
              'The Integrated Trade, Logistics and Industrial Hub of Oman. Khazaen is the largest economic development zone in Greater Muscat, located on the Muscat – Al Batinah Expressway, providing great road access to Oman, the UAE, and Saudi Arabia.',
          },
          '6': { name: 'Name 6', highlight: 'Description 6' },
          '7': {
            name: 'Knowledge Oasis Muscat',
            highlight:
              "Today, we're home to over 200 future-focused domestic, regional and global companies, institutions and organizations. They range from flourishing home-grown SMEs and leading higher education providers to burgeoning businesses capitalizing on KOM's ecosystem.",
          },
          '8': { name: 'Name 8', highlight: 'Description 8' },
          '9': { name: 'Name 9', highlight: 'Description 9' },
          '10': { name: 'Name 10', highlight: 'Description 10' },
          '11': { name: 'Name 11', highlight: 'Description 11' },
          '12': {
            name: 'Duqm Special Economic Zone',
            highlight:
              'The Special Economic Zone at Duqm in Al Wusta is 550 km from Muscat. It is the largest in the Middle East and North Africa, covering 2,000 square kilometers.',
          },
          '13': {
            name: 'Al Mazunah Free Zone',
            highlight:
              "Al Mazunah Free Zone, situated in Oman's Dhofar governorate near the Yemeni border, serves as a key Gulf gateway for transit trade to Yemen and East Africa.",
          },
          '14': { name: 'Name 14', highlight: 'Description 14' },
          '15': {
            name: 'Salalah Free Zone',
            highlight:
              'The Integrated Trade, Logistics and Industrial Hub of Oman. Khazaen is the largest economic development zone in Greater Muscat, located on the Muscat – Al Batinah Expressway, providing great road access to Oman, the UAE, and Saudi Arabia.',
          },
        },
      },
      opportunitiesInOman: {
        title: 'Opportunities in Oman',
        subtitle:
          'Explore high-impact projects aligned with Vision 2040 across logistics, manufacturing, energy, tourism, food security and digital economy.',
        capitalLabel: 'Capital',
        exploreCta: 'Explore more investment opportunities',
        sliderPrevAria: 'Show previous opportunities',
        sliderNextAria: 'Show more opportunities',
        placeholderImageAria: 'Opportunity preview {n}',
        card1: { name: 'Al Jabal AL Aali project', sector: 'Real-Estate', capital: '1,200,000,000 OMR' },
        card2: { name: 'Business Gate', sector: 'Aviation', capital: '260,000,000 OMR' },
        card3: { name: 'Entrepreneurial Boulevard – Salalah', sector: 'Tourism', capital: '40,000,000 OMR' },
        card4: {
          name: 'Cybersecurity as a Service (CaaS) for Small and medium Enterprises',
          sector: 'ICT',
          capital: '7,507,500 OMR',
        },
        card5: { name: 'Early Detection Center', sector: 'Healthcare', capital: '7,500,000 OMR' },
        card6: {
          name: 'Giant Shrimp Farming Project in Ras Madrakah',
          sector: 'Fisheries',
          capital: '32,000,000 OMR',
        },
      },
      livestream: {
        title: 'Livestream',
        subtitle: 'Join us virtually and experience the event in real-time.',
        watchLive: 'Watch Live',
        playVideo: 'Play video',
      },
      footer: {
        connect: 'Connect With Us',
        booklet: 'Download Advantage Oman Booklet',
        register: 'Register to Watch Live on April 27',
        registerWatchLive: 'Register to Watch Live',
        downloadTitle: 'Download Our App',
        downloadSubtitle: 'Access live sessions, participate in real-time engagement, and stay connected throughout the event.',
        downloadAppStore: 'Download on the App Store',
        downloadGooglePlay: 'Get it on Google Play',
        tajawobAlt: 'Tajawob',
        omancircleAlt: 'Invest Oman',
        contactTitle: 'Contact Us',
        contactSubtitle: "Have questions? Send us an inquiry and we'll get back to you shortly.",
        successTitle: 'Message sent successfully!',
        successDesc: "We'll get back to you as soon as possible.",
        errorPrefix: 'Error:',
        nameLabel: 'Name',
        emailLabel: 'Email',
        messageLabel: 'Message',
        namePlaceholder: 'Your name',
        emailPlaceholder: 'your@email.com',
        messagePlaceholder: 'Your message...',
        send: 'Send Inquiry',
        copyright: '© 2026 Invest Oman, All Rights Reserved',
        modalTitle: 'Register Your Interest',
        modalThanksTitle: 'Thank you for your interest!',
        modalThanksDesc: "We've received your information.",
        modalErrorPrefix: 'Error:',
        modalNameLabel: 'Name',
        modalEmailLabel: 'Email',
        modalSubmit: 'Register',
        modalSubmitting: 'Submitting...',
        startInvesting: 'Start Investing',
        investmentOpportunities: 'Investment Opportunities',
        sectors: 'Sectors',
        resourcesTools: 'Resources & Tools',
        investorGuide: 'Investor Guide',
        businessSimulator: 'Business Simulator',
        licensesSimulator: 'Licenses Simulator',
        discover: 'Discover',
        whyOman: 'Why Oman?',
        incentives: 'Incentives',
        reportsPublications: 'Reports & Publications',
        newsAnnouncements: 'News & Announcements',
        successStories: 'Success Stories',
        faqs: 'FAQs',
        aboutInvestOman: 'About Invest Oman',
        aboutUs: 'About Us',
        howCanWeHelp: 'How Can We Help?',
        contactUsLink: 'Contact Us',
        connectColumn: 'Connect',
        omanBusinessPlatform: 'Oman Business Platform',
        freeZones: 'Free Zones',
        industrialZones: 'Industrial Zones',
        needAssistance: 'Need Assistance?',
        emailShort: 'Email:',
        phoneShort: 'Phone:',
        assistanceEmail: 'forum@investoman.om',
        assistancePhone: '+968 80000222',
        copyrightBrand: 'Copyright © 2026 InvestOMAN',
        copyrightLine: 'Copyright © 2026 InvestOMAN',
        rightsReserved: 'All Rights Reserved',
        termsAndConditions: 'Terms and Conditions',
        privacyPolicy: 'Privacy Policy',
        appComingSoonTitle: 'Coming soon',
        appComingSoonMessage:
          'The Invest Oman app will be available on the App Store and Google Play soon. Thank you for your interest.',
        appComingSoonClose: 'Close',
      },
      attend: {
        ctaLabel: 'Express Your Interest to Attend',
        title: 'Express Your Interest to Attend',
        subtitle: 'Share a few details so our team can review your request.',
        fields: {
          name: 'Name',
          company: 'Company',
          designation: 'Designation',
          country: 'Country',
          sector: 'Sector of Interest',
          investmentRange: 'Investment Size Range',
          tourismProgramsHeading: 'Tourism programs (optional)',
          tourismMuscat: 'Attend tourism program — Muscat Tour',
          tourismOmanOvernight: 'Attend tourism program — Oman Tour (includes overnight stay)',
          email: 'Email',
          phone: 'Contact',
          linkedin: 'LinkedIn profile',
          website: 'Company website',
          whyAttend: 'Why should you attend?',
          brief: 'Brief about your company or why you should attend',
          companyCapitalSize: 'Company capital size',
          seniorityLevel: 'Seniority level',
          selectCapital: 'Select company capital size',
          selectSeniority: 'Select seniority level',
        },
        required: 'This field is required.',
        validationNameLength: 'Name must be between 3 and 40 characters.',
        validationCompanyLength: 'Company must be between 1 and 35 characters.',
        validationDesignationLength: 'Designation must be between 1 and 35 characters.',
        validationSectorLength: 'Sector of interest must be between 1 and 35 characters.',
        validationInvestmentLength: 'Investment size range must be between 1 and 35 characters.',
        validationEmail: 'Please enter a valid email address.',
        validationPhoneDigits: 'Contact must contain numbers only.',
        validationWhyAttendLength: 'This field must be between 3 and 1000 characters.',
        submitting: 'Submitting...',
        submit: 'Submit application',
        successMessage: 'Your application is under review. Our team will contact you shortly.',
        errorGeneric: 'Failed to submit your interest. Please try again later.',
      },
      auth: {
        loginTitle: 'Sign in',
        loginSubtitle: 'Use your account to access Advantage Oman.',
        forgotTitle: 'Forgot password',
        forgotSubtitle: 'Receive a secure link to reset your password.',
        emailLabel: 'Email address',
        passwordLabel: 'Password',
        forgotLink: 'Forgot password?',
        backToSignIn: 'Back to sign in',
        signInButton: 'Sign in',
        signingIn: 'Signing in…',
        sendingReset: 'Sending reset link…',
        sendResetButton: 'Send reset link',
        forgotSuccess: 'If this email exists, a reset link has been sent.',
        footerNote: 'Secure access for registered users.',
        emailRequired: 'Please enter your email address.',
        resetErrorGeneric: 'Failed to send reset link.',
        loginErrorGeneric: 'Login failed. Please check your credentials.',
        checkingSession: 'Checking session…',
      },
    },
    dashboard: {
      loading: 'Loading...',
      title: 'Dashboard',
      adminConsole: 'Admin Console',
      switchToArabic: 'Switch to Arabic',
      switchToEnglish: 'Switch to English',
      subtitle: 'Manage forum content',
      overview: 'Overview',
      overviewDescription: 'View forum statistics and quick actions',
      myProfile: 'My Profile',
      myProfileDescription: 'Manage your personal information, security and QR code.',
      guest: 'Guest',
      profile: {
        avatarAlt: 'Profile',
        changePicture: 'Change Picture',
        removePicture: 'Remove Picture',
      },
      profilePersonalInfo: 'Personal Information',
      profileTravelDetails: 'Travel Details',
      profileHotel: 'Hotel',
      profileVisaLetter: 'Visa Letter',
      profileSecurity: 'Security',
      profileDangerZone: 'Danger Zone',
      profileEntryPass: 'Your Entry Pass',
      uniqueAttendeeId: 'ID',
      driverName: 'Driver Name',
      driverContact: 'Driver Contact',
      notProvided: 'Not provided',
      editInRegistration: 'Edit in registration steps',
      edit: 'Edit',
      assignedDriver: 'Your assigned driver',
      changePassword: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm new password',
      deleteAccount: 'Delete account',
      deleteAccountConfirm: 'Are you sure you want to delete your account? This action cannot be undone.',
      deleteAccountUnderstand: 'I understand this action is permanent',
      updatePassword: 'Update password',
      saving: 'Saving...',
      save: 'Save',
      close: 'Close',
      select: 'Select',
      filtersApplied: '{count} filter(s) applied',
      formLabelFullName: 'Full Name *',
      formLabelOrganization: 'Company *',
      formLabelPosition: 'Position *',
      formLabelPhone: 'Contact *',
      formLabelCode: 'Code',
      formLabelNationality: 'Nationality *',
      formLabelCountry: 'Country *',
      formLabelSector: 'Sector *',
      profileFields: {
        companyCapital: 'Company capital size',
        seniorityLevel: 'Seniority level',
        capital1_5m: '1–5 Million USD',
        capital5_10m: '5–10 Million USD',
        capitalAbove10m: 'Above 10 Million USD',
        seniorityCSuite: 'C-Suite',
        seniorityExecutive: 'Executive Leadership',
        seniorityGovernment: 'Government Leadership',
        selectPlaceholder: 'Select…',
        errorCapitalRequired: 'Please select company capital size.',
        errorSeniorityRequired: 'Please select seniority level.',
      },
      profileUpdatedSuccess: 'Profile updated successfully.',
      travelSavedSuccess: 'Travel details saved.',
      hotelSavedSuccess: 'Hotel details saved.',
      visaSavedSuccess: 'Visa letter details saved.',
      passwordChangedSuccess: 'Password changed successfully.',
      pictureUpdatedSuccess: 'Profile picture updated.',
      pictureRemovedSuccess: 'Profile picture removed.',
      removePictureConfirm: 'Remove profile picture?',
      updatingAvatar: 'Updating',
      securityDescription: 'Keep your account secure by using a strong, unique password.',
      dangerDescription: 'Once you delete your account, there is no going back. All your data will be permanently removed.',
      errorUpdateProfile: 'Failed to update profile.',
      errorDeleteAccount: 'Failed to delete account.',
      errorLoadProfile: 'Failed to load profile details.',
      errorPictureTooBig: 'Picture size too big. Please try a smaller image.',
      errorPictureFailed: 'Failed to upload picture. Please try again.',
      errorRemovePicture: 'Failed to remove profile picture.',
      errorSave: 'Failed to save.',
      errorPasswordLength: 'New password must be at least 6 characters long.',
      errorPasswordMismatch: 'New passwords do not match.',
      programs: 'Programs',
      programsDescription: 'Add and manage programs',
      programsPage: {
        noMatch: 'No programs match the selected filters.',
        noMatchHint: 'Try changing the date or audience filter.',
        filters: {
          date: 'Date',
          allDates: 'All dates',
          audience: 'Audience',
        },
        form: {
          fixErrors: 'Please fix the form errors before saving.',
        },
      },
      schedule: 'Schedule',
      scheduleDescription: 'Update event schedule and sessions',
      schedulePage: {
        loading: 'Loading schedule...',
        noEventsForDay: 'No events for Day {day}',
        noEventsHint: 'Try another day filter or add an event.',
        dayOption: 'Day {day}',
      },
      meetingRooms: 'Meeting Rooms',
      meetingRoomsDescription: 'Book and manage meeting room reservations',
      speakers: 'Speakers',
      speakersDescription: 'Add or modify speaker profiles',
      searchSpeakers: 'Search speakers by name, company, type or country',
      speakersPage: {
        loading: 'Loading speakers...',
        filters: {
          allTypes: 'All types',
        },
        validation: {
          nameLength: 'Speaker name must be between 3 and 35 characters.',
          positionLength: 'Position must be between 3 and 35 characters.',
          companyLength: 'Company must be between 3 and 25 characters.',
          bioMax: 'Biography cannot exceed 1,500 characters.',
        },
        form: {
          namePlaceholder: 'Enter full name',
          positionPlaceholder: 'Job title / role',
          companyPlaceholder: 'Organization / institution',
          selectCountry: 'Select country',
          speakerType: 'Speaker Type',
          linkedinPlaceholder: 'https://linkedin.com/in/username',
          shortDescription: 'Short Description',
          bioLabel: 'Biography',
          charCount: '{current} / {max}',
          bioPlaceholder: 'Short bio about the speaker, key topics, achievements...',
          portraitTitle: 'Speaker Portrait',
          portraitSubtitle: 'Upload a clear, square image. This will be used across the app.',
          uploadPhoto: 'Click to upload photo',
        },
        types: {
          government: 'Government',
          privateSector: 'Private Sector',
          international: 'International',
        },
      },
      sponsors: 'Sponsors',
      sponsorsDescription: 'Manage sponsor logos and information',
      sponsorsPage: {
        validation: {
          nameLength: 'Sponsor name must be between 3 and 45 characters.',
          logoRequired: 'Sponsor logo is required.',
          logoPngOnly: 'Logo must be a PNG file (.png).',
        },
        searchPlaceholder: 'Search by name or website…',
        partnerType: 'Partner type',
        allTypes: 'All types',
        loading: 'Loading sponsors...',
        noMatch: 'No sponsors match the selected filters.',
        noMatchHint: 'Try a different search or partner type.',
        visitWebsite: 'Visit website',
        noWebsite: 'No website link',
        uploadLogo: 'Upload logo',
        pngOnlyHint: 'PNG only (required)',
        partnerTypes: {
          strategic: 'Strategic Partner',
          sector: 'Sector Partners',
          media: 'Media Partners',
        },
      },
      attendance: 'Attendance',
      attendanceDescription: 'Track and manage event attendance',
      attendanceLoadError: 'Failed to load attendance records.',
      attendanceLoading: 'Loading attendance…',
      attendanceUniqueGuests: 'Unique guests checked in',
      attendanceTotalScans: 'Total check-in scans',
      attendanceScanUniqueness: 'Unique scan rate',
      attendanceCheckInColumn: 'Check-in',
      refresh: 'Refresh',
      payments: {
        navLabel: 'Payments',
        title: 'Payment Records',
        subtitle: 'Monitor and manage all transaction history from Thawani.',
        anonymousUser: 'Anonymous User',
        totalRevenue: 'Total Revenue',
        searchPlaceholder: 'Search by name, email, payment ID or status...',
        loading: 'Fetching payment history...',
        empty: 'No payment records found matching your search.',
        errors: {
          loadFailed: 'Failed to load payments.',
        },
        filters: {
          status: 'Status',
          all: 'All',
        },
        status: {
          completed: 'Completed',
          pending: 'Pending',
          failed: 'Failed',
          refunded: 'Refunded',
          unknown: 'Unknown',
        },
        records: {
          one: 'record',
          many: 'records',
        },
        fields: {
          session: 'Session',
          payment: 'Payment',
          method: 'Method',
        },
      },
      applicants: {
        title: 'Interest Applications',
        description: 'Review and manage applicants who expressed interest in attending via the homepage.',
        add: 'ADD APPLICANT',
        added: 'APPLICANT ADDED',
        notesSaved: 'Notes saved',
        empty: 'No applications found.',
        manualAddTitle: 'Add Application',
        manualAddSubtitle: 'Create a new user profile manually',
        autoPassword: 'Auto Password Prediction',
        creating: 'Creating...',
        createProfile: 'Create Applicant Profile',
        userCreated: 'User created successfully.',
        tempPassword: 'Temporary password',
        savePasswordNow: 'Save this password now.',
        errors: {
          loadApplicants: 'Failed to load applicants',
          updateStatus: 'Failed to update status',
          saveNotes: 'Failed to save notes',
          nameLength: 'Name must be between 3 and 35 characters.',
          invalidEmail: 'Please enter a valid email address.',
        },
        filters: {
          status: 'Status',
          allStatuses: 'All statuses',
          country: 'Country',
          allCountries: 'All countries',
          sector: 'Sector',
          allSectors: 'All sectors',
        },
        countOne: 'applicant',
        countMany: 'applicants',
        labels: {
          personalInfo: 'Personal & Professional Info',
          investmentDetails: 'Sector & tourism',
          motivation: 'Motivation & Reason',
          adminNotes: 'Internal Admin Notes',
          notesPlaceholder: 'Add internal notes about this applicant...',
          saveNotes: 'Save Notes',
          saving: 'Saving...',
          submittedOn: 'Submitted on',
          lastUpdated: 'Last updated on',
          noReason: 'No reason provided.',
          searchPlaceholder: 'Search applicants...'
        },
        statuses: {
          under_review: 'Under Review',
          approved: 'Approved',
          rejected: 'Rejected',
          waitlisted: 'Waitlisted'
        }
      },
      applicantSetup: {
        loading: 'Loading applicant setup...',
        title: 'Applicant Onboarding',
        subtitle: 'Complete your profile, then submit seat payment.',
        steps: {
          profile: 'Profile data',
          payment: 'Seat payment',
        },
        selectNationality: 'Select nationality',
        selectCountry: 'Select country',
        payment: {
          title: 'Seat Payment',
          subtitle: 'Select your seat category and complete payment.',
          seatTier: 'Seat Tier',
          tier: {
            standard: 'Standard - 50 OMR',
            vip: 'VIP - 60 OMR',
            partner: 'Partner allocation - 60 OMR',
          },
          cardHolder: 'Card Holder Name',
          cardNumber: 'Card Number',
          expiry: 'Expiry (MM/YY)',
          cvv: 'CVV',
          backToProfile: 'Back to Profile',
          processing: 'Processing...',
          submit: 'Submit Payment',
        },
      },
      linkedin: 'LinkedIn',
      role: 'Role',
      organization: 'Company',
      status: 'Status',
      vip: 'VIP',
      investor: 'Investor',
      investorTypes: {
        typeLabel: 'Investor type',
        overseas: 'Overseas investor',
        omani: 'Omani investor',
        expatInOman: 'Investor in Oman (Expat)',
        selectPlaceholder: 'Select investor type…',
        errorRequired: 'Select an investor type when Investor is on.',
      },
      roles: {
        participant: 'Participant',
        delegate: 'Delegate',
        speaker: 'Speaker',
        sponsor: 'Sponsor',
        media: 'Media',
        organizer: 'Organizer',
        admin: 'Admin',
        applicant: 'Applicant',
        super_admin: 'Super Admin',
      },
      type: 'Type',
      placeholders: {
        fullName: 'e.g. John Doe',
        email: 'john@example.com',
        flightNumber: 'e.g. WY 101',
        hotelName: 'e.g. Al Bustan Palace',
        sponsorName: 'e.g. Petroleum Development Oman',
        websiteUrl: 'https://company.com',
      },
      guestsPage: {
        loading: 'Loading users...',
        allDates: 'All dates',
        idLabel: 'ID',
        invitation: 'Invitation',
        rsvp: 'RSVP',
        restore: 'Restore',
        roleChangeSuperAdminOnly: 'Only a super admin can change this user\'s role.',
      },
      guests: 'Guests',
      guestsDescription: 'Manage event guests and registrations',
      livestream: 'Livestream',
      livestreamDescription: 'Manage livestream settings and URLs',
      logisticsInfo: 'Logistics Info',
      logisticsInfoDescription: 'View travel, hotel and visa details for all registered attendees.',
      logisticsPage: {
        summary: {
          attendees: 'Attendees',
          flightsIssued: 'Flights Issued',
          hotelsAssigned: 'Hotels Assigned',
          visaReady: 'Visa Ready',
        },
        searchPlaceholder: 'Search by name, email or flight number…',
        empty: 'No travel details found.',
        errors: {
          loadFailed: 'Failed to load.',
          saveFailed: 'Failed to save changes.',
          uploadFailed: 'Upload failed.',
          fileType: 'Please upload a PDF or Image file.',
          fileTooLarge: 'File is too large. Max 10MB.',
        },
        validation: {
          flightNumber: 'Flight number is required (1–10 characters).',
          flightDatesRequired: 'Arrival and departure dates are required when flight is issued.',
          arrivalNotPast: 'Arrival date cannot be in the past.',
          departureNotPast: 'Departure date cannot be in the past.',
          hotelNameMax: 'Hotel name cannot exceed 35 characters.',
          hotelCheckoutAfterCheckin: 'Check-out date must be after check-in date.',
          visaFullNameMax: 'Full name cannot exceed 35 characters.',
          visaPassportMax: 'Passport cannot exceed 25 characters.',
          visaRequiredFields: 'Full name and passport are required when visa letter is required.',
        },
        pills: {
          flight: 'Flight',
          noFlight: 'No Flight',
          hotel: 'Hotel',
          noHotel: 'No Hotel',
          visaPrefix: 'Visa',
        },
        filters: {
          allCountries: 'All countries',
          allSectors: 'All sectors',
          vipOnly: 'VIP only',
          nonVip: 'Non‑VIP',
          complete: 'Complete',
          needsAttention: 'Needs attention',
          noneApplied: 'No filters applied',
          reset: 'Reset filters',
        },
        flight: {
          title: 'Flight',
          issuedLabel: 'Issued',
          issued: 'Issued',
          notIssued: 'Not issued',
          flightNumber: 'Flight #',
          arrivalDate: 'Arrival Date',
          arrivalTime: 'Arrival Time',
          departureDate: 'Departure Date',
          departureTime: 'Departure Time',
        },
        hotel: {
          title: 'Hotel',
          statusLabel: 'Status',
          assigned: 'Assigned',
          notAssigned: 'Not assigned',
          name: 'Name',
          checkInShort: 'In',
          checkOutShort: 'Out',
          checkIn: 'Check-in',
          checkOut: 'Check-out',
        },
        visa: {
          title: 'Visa Letter',
          requiredLabel: 'Required',
          issuedLabel: 'Issued',
          required: 'Required',
          notRequiredLower: 'Not required',
          notRequired: 'Not Required',
          issued: 'Issued',
          notIssued: 'Not issued',
          pending: 'Pending',
          fullName: 'Full Name',
          passport: 'Passport',
          requestInfo: 'Request Info',
          viewIssued: 'View Issued Letter',
          viewDocument: 'View Document',
          update: 'Update Visa Letter',
          upload: 'Upload Visa Letter',
          processing: 'Processing upload...',
          uploadSuccess: 'Visa letter uploaded successfully.',
        },
        notes: {
          title: 'Internal Notes',
          optionalHint: '(optional, max {max} characters)',
          placeholder: "Add any internal notes about this attendee's logistics, preferences or special arrangements...",
        },
        detail: {
          titleFallback: 'Attendee details',
        },
      },
      paymentsDescription: 'View and track all registration payments and transaction history.',
      analytics: 'Analytics',
      analyticsDescription: 'Visualize countries, inbound travel, investor capital and sector distribution.',
      analyticsPage: {
        loading: 'Loading analytics...',
        live: 'Live data',
        subtitle: 'Comprehensive overview of attendees, travel logistics, and sectors.',
        errors: {
          load: 'Failed to load analytics data.',
        },
        labels: {
          unspecified: 'Unspecified',
          unknown: 'Unknown',
        },
        inbound: {
          international: 'International',
          local: 'Local (Oman)',
          localShort: 'Local',
        },
        kpis: {
          totalAttendees: 'Total Attendees',
          countries: 'Countries',
          vip: 'VIP Guests',
          flightsIssued: 'Flights Issued',
          payments: 'Payments',
          investorOne: 'investor',
          investorMany: 'investors',
          international: 'international',
          ofAttendees: 'of attendees',
          total: 'total',
          noPayments: 'No payment data',
        },
        charts: {
          countries: 'Country Distribution',
          top: 'Top',
          countriesWord: 'countries',
          outOf: 'out of',
          inbound: 'Inbound vs Local',
          inboundSubtitle: 'International travelers vs Oman-based',
          sectors: 'Sector Distribution',
          sectorsRepresented: 'sectors represented',
          roles: 'Role Breakdown',
          rolesSubtitle: 'Distribution of attendee roles',
        },
        empty: {
          generic: 'No data available',
          countries: 'No country data available',
          sectors: 'No sector data available',
          roles: 'No role data available',
        },
        travelStatus: {
          title: 'Travel & Logistics Status',
          subtitle: '{count} travel records',
          pending: 'pending',
          bars: {
            flightsIssued: 'Flights Issued',
            hotelsAssigned: 'Hotels Assigned',
            visaIssued: 'Visa Issued',
            pickupReady: 'Pickup Ready',
          },
          cards: {
            flights: 'Flights',
            hotels: 'Hotels',
            visa: 'Visa',
            pickup: 'Pickup',
          },
        },
      },
      seatAllocationDescription: 'Theatre-style seating map with color-coded categories and PDF export',
      manageDownloadGuide: 'Manage Investor Guide & Booklet',
      downloadGuide: 'Investor Guide & Booklet',
      downloadGuideDescription: 'Manage the downloadable investor guide used in the navigation bar and footer booklet button',
      alert: 'Alert',
      alertDescription: 'Send Alert to all users',
      backToHome: 'Back to Home',
      home: 'Home',
      logout: 'Logout',
      welcome: 'Welcome back',
      subtitleDescription: 'Manage speakers, sponsors, schedule, livestream and more in one unified, modern control center tailored for the Advantage Oman experience.',
      addCourse: 'Add Program',
      editCourse: 'Edit Program',
      startTime: 'Start Time',
      endTime: 'End Time',
      capacity: 'Capacity',
      clickToAddFirstProgram: 'Click the + button to add your first program',
      clickToAddFirstMeetingRoom: 'Click the + button to add your first meeting room',
      clickToAddFirstGuest: 'Click the + button to add your first guest',
      deleteGuestConfirm: 'Are you sure you want to delete this guest?',
      guestDeleted: 'Guest deleted successfully',
      guestAdded: 'Guest added successfully',
      guestUpdated: 'Guest updated successfully',
      noGuestsFound: 'No guests found',
      titleMaxLength: 'Title cannot exceed 100 characters',
      subtitleMaxLength: 'Subtitle cannot exceed 100 characters',
      locationMaxLength: 'Location cannot exceed 100 characters',
      attendanceInfoMaxLength: 'Attendance info cannot exceed 100 characters',
      chatEnabled: 'Chat feature enabled',
      chatDisabled: 'Chat feature disabled',
      livestreamSaved: 'Livestream settings saved successfully.',
      editForumOverview: 'Edit Forum Overview',
      mainTitle: 'Main Title',
      subTitle: 'Subtitle',
      startDate: 'Start Date',
      endDate: 'End Date',
      location: 'Location',
      attendanceInfo: 'Attendance Information',
      userRole: 'User Role',
      allUsers: 'All users',
      user: 'User',
      delegate: 'Delegate',
      saveChanges: 'Save Changes',
      dismiss: 'Dismiss',
      titleRequired: 'Title is required',
      startDateAfterEndDate: 'Start date cannot be after end date',
      pleaseFixErrors: 'Please fix the errors before saving',
      manageSchedule: 'Manage Schedule',
      addEvent: 'Add Event',
      editEvent: 'Edit Event',
      deleteEvent: 'Delete Event',
      eventName: 'Event Name',
      eventDescription: 'Event Description',
      day: 'Day',
      deleteEventConfirm: 'Are you sure you want to delete this event?',
      eventAdded: 'Event added successfully!',
      eventUpdated: 'Event updated successfully!',
      eventDeleted: 'Event deleted successfully!',
      noEventsYet: 'No events added yet',
      tapToAddEvents: 'Tap the + button to add events',
      manageSpeakers: 'Manage Speakers',
      addSpeaker: 'Add Speaker',
      addNewSpeaker: 'Add New Speaker',
      editSpeaker: 'Edit Speaker',
      deleteSpeaker: 'Delete Speaker',
      speakerName: 'Speaker Name',
      position: 'Position',
      company: 'Company',
      bio: 'Biography',
      deleteSpeakerConfirm: 'Are you sure you want to delete this speaker?',
      male: 'Male',
      female: 'Female',
      speakerAdded: 'Speaker added successfully!',
      speakerUpdated: 'Speaker updated successfully!',
      speakerDeleted: 'Speaker deleted successfully!',
      noSpeakersYet: 'No speakers added yet',
      tapToAddSpeakers: 'Tap the + button to add speakers',
      manageSponsors: 'Manage Sponsors',
      addSponsor: 'Add Sponsor',
      addNewSponsor: 'Add New Sponsor',
      editSponsor: 'Edit Sponsor',
      deleteSponsor: 'Delete Sponsor',
      sponsorName: 'Sponsor Name',
      sponsorLogo: 'Sponsor Logo',
      website: 'Website',
      deleteSponsorConfirm: 'Are you sure you want to delete this sponsor?',
      sponsorAdded: 'Sponsor added successfully!',
      sponsorUpdated: 'Sponsor updated successfully!',
      sponsorDeleted: 'Sponsor deleted successfully!',
      noSponsorsYet: 'No sponsors added yet',
      tapToAddSponsors: 'Tap the + button to add sponsors',
      manageLivestream: 'Manage Livestream',
      streamStatus: 'Stream Status',
      livestreamStatus: 'Livestream Status',
      live: 'LIVE',
      offline: 'OFFLINE',
      streamInformation: 'Stream Information',
      youtubeUrl: 'YouTube URL',
      enterYoutubeUrl: 'Enter YouTube livestream URL',
      appLink: 'App Link',
      enterAppLink: 'Enter app link (optional)',
      manageGuests: 'Manage Guests',
      addGuest: 'Add Guest',
      updateGuest: 'Update Guest',
      fullName: 'Full Name',
      email: 'Email',
      username: 'Username',
      attendanceRecords: 'Attendance Records',
      present: 'Present',
      total: 'Total',
      rate: 'Rate',
      country: 'Country',
      sector: 'Sector',
      arrivalDate: 'Arrival Date',
      all: 'All',
      yes: 'Yes',
      no: 'No',
      absent: 'Absent',
      checkedIn: 'Checked-in',
      searchAttendees: 'Search attendees...',
      noRecordsFound: 'No attendance records found',
      name: 'Name',
      description: 'Description',
      date: 'Date',
      time: 'Time',
      add: 'Add',
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
      nameRequired: 'Name is required',
      descriptionRequired: 'Description is required',
      fillRequiredFields: 'Please fill in all required fields',
      comingSoon: 'Coming Soon',
      gender: 'Gender',
      positionRequired: 'Position is required',
      companyRequired: 'Company is required',
      nameMaxLength: 'Name cannot exceed 100 characters',
      linkRequired: 'Website link is required',
      linkMaxLength: 'Link cannot exceed 500 characters',
      linkInvalid: 'Link must start with http:// or https://',
      logoRequired: 'Sponsor logo is required',
      overviewSaved: 'Overview saved successfully',
      fileName: 'File name',
      fileNamePlaceholder: 'Advantage Oman Investor Guide 2026 (PDF)',
      fileUrl: 'File URL',
      fileNameRequired: 'File name is required',
      fileUrlRequired: 'File URL is required',
      fileUrlInvalid: 'URL must start with http:// or https://',
      downloadGuideSaved: 'Download guide updated successfully!',
      currentGuidePreview: 'Current public link',
      currentGuideHelper: 'This link powers the "Investor Guide" button in the navigation and the "Download Advantage Oman Booklet" button in the footer.',
      noGuideConfigured: 'No guide is configured yet. Add a file URL and save to enable the download buttons on the website.',
      downloadGuideNote: 'Paste a publicly accessible URL to the PDF (for example from Supabase Storage or your CDN). This link is shared on the website navigation and footer.',
      downloadGuideInfoTitle: 'Where is this used?',
      downloadGuideInfoNav: 'Main website navigation button: "Investor Guide".',
      downloadGuideInfoFooter: 'Footer button: "Download Advantage Oman Booklet".',
      downloadGuideVisitorsHint: 'Visitors will download this file when they click the "Investor Guide" or "Booklet" buttons.',
      displayName: 'Display Name',
      viewDocument: 'View Document',
      download: 'Download',
      redirecting: 'Redirecting...',
      fileUpload: 'Upload PDF file',
      deleteProgramConfirm: 'Are you sure you want to delete this program?',
      programDeleted: 'Program deleted successfully',
      programSaved: 'Program saved successfully',
      noProgramsAvailable: 'No programs available',
      meetingRoomManagement: {
        addNewRoom: 'Add New Meeting Room',
        editRoom: 'Edit Meeting Room',
        roomNameRequired: 'Room Name*',
        amenities: 'Amenities',
        amenitiesPlaceholder: 'Projector, Whiteboard, Video Call...',
        capacity: 'Capacity',
        capacityAny: 'Any capacity',
        capacity1to25: '1–25',
        capacity25to50: '25–50',
        capacity50to75: '50–75',
        capacity75plus: '75+',
        searchPlaceholder: 'Search by room name, location or description…',
        loading: 'Loading meeting rooms...',
        noMatch: 'No rooms match the selected filters.',
        noMatchHint: 'Try a different search or capacity range.',
        enterRoomName: 'Please enter a room name',
        loginRequired: 'You must be logged in to add a room',
        addSuccess: 'Meeting room added successfully',
        addError: 'Failed to add meeting room',
        updateSuccess: 'Meeting room updated successfully',
        updateError: 'Failed to update meeting room',
        confirmDeleteTitle: 'Confirm Delete',
        confirmDeleteMessage: 'Are you sure you want to delete this meeting room?',
        deleteSuccess: 'Meeting room deleted successfully',
        deleteError: 'Failed to delete meeting room',
        fetchError: 'Failed to load meeting rooms',
        noRooms: 'No meeting rooms added yet',
      },
      users: 'Users',
      admins: 'Admins',
      delegates: 'Delegates',
      checkInStaff: 'Check-in Staff',
      vendors: 'Vendors',
      media: 'Media',
      superAdmin: {
        chatManagement: 'Chat Feature Management',
        chatDescription: 'Enable or disable optional chat features',
        chatFeature: 'Chat Feature',
        enabled: 'Enabled',
        disabled: 'Disabled',
        dangerZone: 'Danger Zone',
        resetDescription: 'Reset the entire application to factory defaults. This will:',
        deleteEventData: 'Delete all event data',
        resetColors: 'Reset colors to default',
        logoutApp: 'Log you out of the app',
        resetButton: 'Reset App to Factory Default',
        resetting: 'Resetting',
        resetAlert: {
          message: 'This will permanently delete all event data, bookings, attendance records, and user accounts. This action cannot be undone!',
        },
        resetSuccess: {
          message: 'The system has been reset to factory defaults.',
        },
      },
      profileSetup: {
        title: 'Complete Your Profile',
        subtitle: 'Please complete your profile details before continuing.',
        searchPlaceholder: 'Search...',
        loading: 'Loading profile...',
        fullName: 'Full Name *',
        email: 'Email',
        designation: 'Designation',
        company: 'Company',
        nationality: 'Nationality *',
        country: 'Country *',
        phone: 'Contact *',
        sector: 'Sector *',
        selectCountry: 'Select country',
        selectNationality: 'Select nationality',
        saving: 'Saving...',
        saveAndContinue: 'Save & Continue',
        completeProfile: 'Complete Profile',
        errorFullName: 'Full name is required (3-35 characters).',
        errorDesignation: 'Designation is required (1-30 characters).',
        errorCompany: 'Company is required (1-40 characters).',
        errorNationality: 'Nationality is required (3-25 characters).',
        errorCountry: 'Country is required.',
        errorCountryCode: 'Please choose a valid country code.',
        errorPhone: 'Contact is required and must be numbers only (up to 10 digits).',
        errorSector: 'Sector is required (1-45 characters).',
        errorCapital: 'Company capital size is required.',
        errorSeniority: 'Seniority level is required.',
        errorLoad: 'Failed to load profile.',
        errorComplete: 'Failed to complete profile.',
      },
      registrationSteps: {
        yourProgress: 'Your progress',
        inProgress: 'In progress',
        completed: 'Completed',
        backStep: 'Back',
        step1: 'Profile Setup',
        step2: 'Travel Details',
        step3: 'Hotel',
        step4: 'Visa Letter',
      },
      travelDetails: {
        title: 'Travel Details',
        subtitle: 'Tell us about your travel plans for the forum.',
        flightIssued: 'Flight Issued',
        flightNumber: 'Flight Number',
        arrivalDate: 'Arrival Date',
        arrivalTime: 'Arrival Time',
        departureDate: 'Departure Date',
        departureTime: 'Departure Time',
        yes: 'Yes',
        no: 'No',
        errors: {
          flightIssuedRequired: 'Please provide if flight has been issued.',
          flightNumberTooLong: 'Flight number must be at most 7 characters.',
        },
        save: 'Save & Continue',
        saving: 'Saving...',
      },
      hotel: {
        title: 'Hotel Accommodation',
        subtitle: 'Select or confirm your hotel stay for the forum.',
        hotelAssigned: 'Hotel',
        hotelName: 'Hotel Name',
        checkIn: 'Check-in Date',
        checkOut: 'Check-out Date',
        roomType: 'Room Type',
        save: 'Save & Continue',
        saving: 'Saving...',
      },
      visaLetter: {
        title: 'Visa Letter',
        subtitle: 'Request an invitation letter for your visa application.',
        note: 'Note: these countries require a visa letter — Pakistan, Bangladesh, Sri Lanka, Nepal, Nigeria, Ethiopia, Somalia, Yemen, Sudan.',
        visaLetterRequired: 'Visa Letter Required',
        visaLetterIssued: 'Visa Letter Issued',
        fullName: 'Full Name (as on passport)',
        passportNumber: 'Passport Number',
        nationality: 'Nationality',
        requestLetter: 'Request Letter',
        requested: 'Letter requested',
        saving: 'Saving...',
      },
      seatAllocation: {
        title: 'Seat Allocation',
        subtitle: 'Theatre-style seating map with color-coded categories. Assign categories and lock seats.',
        seatingMap: 'Seating Map',
        seatingPlans: 'Seating plans',
        stage: 'Stage',
        stageLong: 'Stage — Main Hall',
        legend: 'Legend – select a category then click a seat to assign',
        clickToAssign: 'Click a seat to assign the selected category.',
        shiftClickToLock: 'Shift+click a seat to lock or unlock it.',
        exportPdf: 'Export PDF',
        addPlan: 'Add seating plan',
        loadingPlans: 'Loading seat plans...',
        saving: 'Saving...',
        saveChanges: 'Save Changes',
        saved: 'Saved',
        duplicate: 'Duplicate',
        emptyTitle: 'No seating plans yet',
        emptySubtitle: 'Create your first seating plan to start designing hall layouts with custom formations.',
        createFirstPlan: 'Create First Plan',
        doneEditing: 'Done Editing',
        editLayout: 'Edit Layout',
        add: 'Add',
        removePlan: 'Remove plan',
        confirmRemovePlanTitle: 'Remove seating plan?',
        confirmRemovePlanMessage: 'This will permanently remove the seating plan "{name}". This action cannot be undone.',
        cancel: 'Cancel',
        remove: 'Remove',
        planNamePlaceholder: 'e.g. Day 3 or Programme 2',
        planLabel: 'Plan {number}',
        planName: 'Plan Name',
        rows: 'Rows',
        seatsPerRow: 'Seats per Row',
        locked: 'Locked',
        toolbar: {
          rows: 'Rows',
          cols: 'Cols',
          aisles: 'Aisles',
          doors: 'Doors',
          addRowTop: 'Add row at top',
          removeRowTop: 'Remove row from top',
          addRowBottom: 'Add row at bottom',
          removeRowBottom: 'Remove row from bottom',
          addColLeft: 'Add column at left',
          removeColLeft: 'Remove column from left',
          addColRight: 'Add column at right',
          removeColRight: 'Remove column from right',
          insertV: 'Insert vertical aisle',
          insertH: 'Insert horizontal aisle',
          eraserHelp: 'Click any seat to remove it. Click an empty cell to add a seat back.',
        },
        statistics: 'Statistics',
        stats: {
          total: 'Total',
          locked: 'Locked',
          assigned: 'Assigned',
        },
        eraser: 'Eraser',
        on: 'ON',
        aisle: 'aisle',
        tooltips: {
          removeAisle: 'Remove aisle',
          insertVerticalAisle: 'Insert vertical aisle',
          addSeatLeft: 'Add seat left',
          removeSeatLeft: 'Remove seat left',
          addSeatRight: 'Add seat right',
          removeSeatRight: 'Remove seat right',
          clickToAddSeat: 'Click to add seat',
          addTopSeat: 'Add top seat',
          removeTopSeat: 'Remove top seat',
          addBottomSeat: 'Add bottom seat',
          removeBottomSeat: 'Remove bottom seat',
        },
        vip: 'VIP',
        government: 'Government VIP',
        omanGovernment: 'Oman Government',
        investor: 'Investor',
        speaker: 'Speaker',
        general: 'General',
        media: 'Media',
        addRow: 'Add row',
        removeRow: 'Remove row',
        addColumn: 'Add column',
        removeColumn: 'Remove column',
        rowsCols: 'rows × cols',
        doors: 'Entrance & Exit Doors',
        doorsHelp: 'Add entrance and exit doors to the seating map. They appear on the edges.',
        addEntrance: 'Add entrance',
        addExit: 'Add exit',
        entrance: 'Entrance',
        exit: 'Exit',
        doorSide: 'Side',
        doorPosition: 'Position',
        doorAlignment: 'Alignment',
        alignmentLeft: 'Left',
        alignmentCenter: 'Center',
        alignmentRight: 'Right',
        doorLabel: 'Label (optional)',
        doorLabelPlaceholder: 'e.g. Main, Side 1',
        sideTop: 'Top',
        sideBottom: 'Bottom',
        sideLeft: 'Left',
        sideRight: 'Right',
        removeDoor: 'Remove door',
        noDoorsYet: 'No doors added. Add entrances or exits above.',
        assignedToLabel: 'Assigned to',
        assignToLabel: 'Assign to (name or email)',
        assignToPlaceholder: 'e.g. John Doe or email',
        lockSeat: 'Lock seat',
        unlockSeat: 'Unlock',
        selectedSeat: 'Selected seat',
        assignedSeatsList: 'Assigned seats',
        nameHeader: 'Name',
        seatNumber: 'Seat',
      },
      announcements: {
        title: 'Announcements',
        subtitle:
          'Create and send important updates, schedule changes and logistics notices to everyone using the app.',
        headerSubtitle: 'Manage dual-channel messaging with separate streams for in-app alerts and email campaigns.',
        cardDescription:
          'Create and manage announcements that appear instantly inside the Advantage Oman app.',
        searchLabel: 'Search announcements',
        searchPlaceholder: 'Search by title or content…',
        searchAppPlaceholder: 'Search app announcements…',
        searchEmailPlaceholder: 'Search email announcements…',
        statusLabel: 'Status',
        categoryLabel: 'Category',
        labelLabel: 'Label',
        newAnnouncement: 'New Announcement',
        formTitle: 'Create announcement',
        titleLabel: 'Title',
        titlePlaceholder: 'Write a clear, concise title…',
        messageLabel: 'Message',
        messagePlaceholder:
          'Write the full announcement that will appear inside the app. Keep it short and action‑oriented.',
        categoryPlaceholder: 'e.g. General, Logistics, Program',
        statusPublished: 'Published',
        statusScheduled: 'Scheduled',
        statusDraft: 'Draft',
        sendPushLabel: 'Send push notification',
        sendPushHelp:
          'If enabled, attendees who installed the app may receive a notification when this is published.',
        scheduleLabel: 'Schedule for later',
        scheduleHelp: 'Optional. Leave empty to send immediately.',
        createButton: 'Send announcement',
        creatingButton: 'Sending…',
        createdSuccess: 'Announcement sent successfully.',
        createdError: 'Failed to send announcement.',
        noAnnouncementsTitle: 'No announcements yet.',
        noAnnouncementsBody:
          'Once you start sending updates, they will appear here in a clean, chronological feed.',
        rolesLabel: 'Who should see this?',
        alertDescription: 'Send an in‑app alert to selected roles.',
        detailTitle: 'Announcement Details',
        targetAudience: 'Target Audience',
        sentTo: 'Sent to',
        recipientsWord: 'recipients',
        allLabels: 'All labels',
        noLabel: 'No Label',
        additionalEmails: 'Additional recipient emails (not registered)',
        additionalEmailsHint: 'Enter one or multiple emails separated by comma or new line.',
        channelEmail: 'Email',
        channelApp: 'App',
        untitled: 'Untitled announcement',
        statTotal: 'Total',
        appColumnTitle: 'App Announcements',
        appColumnSubtitle: 'Push announcements and in-app alerts',
        emailColumnTitle: 'Email Announcements',
        emailColumnSubtitle: 'Newsletter-style communication by email',
        newApp: 'New App',
        newEmail: 'New Email',
        noAppAnnouncements: 'No app announcements',
        noEmailAnnouncements: 'No email announcements',
        createFirst: 'Create your first one using the button above.',
        item: 'item',
        items: 'items',
        createEmailTitle: 'Create Email Announcement',
        createAppTitle: 'Create App Announcement',
        createEmailDesc: 'Compose and send via email to selected recipients.',
        createAppDesc: 'Push an in-app alert to selected user groups.',
        titleMessageRequired: 'Title and message are required',
        selectRoleApp: 'Please select at least one role for app announcements.',
        selectRoleOrEmail: 'Select at least one role or add at least one external email.',
        emailSentSuccess: 'Email announcement sent successfully.',
        appSentSuccess: 'App announcement created successfully.',
        feedUnavailable: 'Announcements feed is not available yet. You can still create new announcements.',
        registeredUsers: 'Registered users',
        notRegistered: 'Not registered (external)',
        registeredShort: 'Registered',
        notRegisteredShort: 'Not registered',
        labelUpdate: 'Update',
        labelUrgent: 'Urgent',
        labelReminder: 'Reminder',
        labelLogistics: 'Logistics',
        labelSchedule: 'Schedule Change',
        labelWelcome: 'Welcome',
        labelNetworking: 'Networking',
        labelGeneral: 'General Info',
        paginationPrev: 'Previous',
        paginationNext: 'Next',
        paginationSummary: '{start}–{end} of {total}',
      },
      export: {
        title: 'Export',
        description: 'Export guests, programs, schedule, attendance, logistics, payments and more to Excel or PDF.',
        cardDescription: 'Export guests, programs, schedule, attendance, logistics, payments and more to Excel or PDF.',
        fullGuests: 'Full list of guests',
        fullGuestsDesc: 'All registered guests with details.',
        programs: 'Programs',
        programsDesc: 'Forum programs list.',
        schedule: 'Schedule',
        scheduleDesc: 'Event schedule.',
        sponsors: 'Sponsors',
        sponsorsDesc: 'Sponsors list.',
        speakers: 'Speakers',
        speakersDesc: 'Speakers list.',
        attendance: 'Attendance',
        attendanceDesc: 'Attendance list with arrival info.',
        seatAllocation: 'Seat allocation',
        seatAllocationDesc: 'Export seating plan as PDF (same as Seat Allocation page).',
        selectSeatPlan: 'Select seating plan',
        fromDate: 'From date',
        interestedApplications: 'Interested applications',
        interestedApplicationsDesc: 'Applications with full details.',
        applicationsLabel: 'Applications',
        logisticsRecords: 'Records',
        visaLettersGuests: 'Guests',
        pdfGeneratedFrom: 'Generated from Advantage Oman Dashboard',
        logistics: 'Logistics',
        logisticsDesc: 'Travel, hotel, visa and pickup details.',
        airportArrivals: 'Airport arrivals only',
        airportArrivalsDesc: 'By arrival date and time. Choose from date to filter.',
        paymentRecords: 'Payment records',
        paymentRecordsDesc: 'All payment records from the Payments page.',
        visaLettersRequired: 'Visa letters required',
        visaLettersRequiredDesc: 'Guests who have requested a visa letter (travel details).',
        guestsByCategory: 'Guests by category',
        guestsByCategoryDesc: 'Export guests filtered by role (e.g. Media, Speaker, Sponsor). Select one or more categories.',
        buttons: {
          excel: 'Excel',
          pdf: 'PDF',
          exportPdf: 'Export PDF',
        },
        labels: {
          fullName: 'Full Name',
          email: 'Email',
          username: 'Username',
          organization: 'Company',
          position: 'Position',
          role: 'Role',
          country: 'Country',
          sector: 'Sector',
          vip: 'VIP',
          investor: 'Investor',
        },
        errors: {
          exportFailed: 'Export failed',
        },
      },
      driverPickup: {
        title: 'Driver Pickup',
        subtitle: 'Assign drivers quickly with drag-and-drop or one-click selection.',
        export: 'Export',
        guests: 'Guests',
        assigned: 'Assigned',
        unassigned: 'Unassigned',
        drivers: 'Drivers',
        loadingData: 'Loading pickup data...',
        guestsArrival: 'Guests (Arrival)',
        searchGuestsPlaceholder: 'Search guests by name, email or flight...',
        allAssignments: 'All assignments',
        assignedOnly: 'Assigned only',
        unassignedOnly: 'Unassigned only',
        noGuestsMatch: 'No guests match current filters.',
        assignedStatus: 'Assigned',
        pendingStatus: 'Pending',
        assignments: 'Assignments',
        arrivalDate: 'Arrival Date',
        arrivalTime: 'Arrival Time',
        flightNumber: 'Flight Number',
        dragHint: 'Drag a driver here, or use quick assign.',
        quickAssign: 'Quick assign driver',
        assign: 'Assign',
        clear: 'Clear',
        addDriver: 'Add Driver',
        searchDriversPlaceholder: 'Search drivers...',
        noDriversFound: 'No drivers found.',
        dragCardHint: 'Drag this card to a guest',
        viewWorkload: 'View Workload',
        removeDriver: 'Remove Driver',
        addNewDriver: 'Add New Driver',
        driverNamePlaceholder: 'Driver name',
        driverContactPlaceholder: 'Driver contact',
        saveDriver: 'Save Driver',
        driverWorkload: 'Driver Workload',
        noGuestsAssignedToDriver: 'No guests assigned to this driver.',
        arrival: 'Arrival',
        exportDriverPickup: 'Export Driver Pickup',
        whatToExport: 'What to export',
        allGuests: 'All guests',
        assignedGuestsOnly: 'Assigned guests only',
        exactArrivalDate: 'Exact arrival date',
        specificDriverWorkload: 'Specific driver workload',
        selectDate: 'Select date',
        selectDriver: 'Select driver',
        selectADriver: 'Select a driver',
        exportExcel: 'Export Excel',
        exportPdf: 'Export PDF',
        confirmClearAssignment: 'Clear pickup assignment for this guest?',
        failedClearAssignment: 'Failed to clear assignment.',
        enterDriverDetails: 'Please enter driver name and contact.',
        driverExists: 'This driver already exists.',
        confirmRemoveDriver: 'Remove this driver? Existing guest assignments will remain until manually changed.',
        exportFailed: 'Export failed.',
        pdfTitle: 'Driver Pickup Export',
        pdfFooter: 'Driver Pickup Report',
        brand: 'Advantage Oman',
        generated: 'Generated',
        role: 'Role',
        driver: 'Driver',
        driverPhone: 'Driver Phone',
        status: 'Status',
        driverWorkloadExport: 'Driver workload export',
      },
    },
  },
  ar: {
    website: {
      common: {
        loading: 'جارٍ التحميل...',
        error: 'حدث خطأ. يرجى المحاولة لاحقاً.',
        viewDetails: 'عرض التفاصيل',
        visit: 'زيارة',
      },
      nav: {
        home: 'الرئيسية',
        about: 'حول المنتدى',
        schedule: 'الجدول',
        speakers: 'المتحدثون',
        opportunities: 'الفرص',
        sponsors: 'الشركاء',
        whyOman: 'لماذا عُمان؟',
        ctaInvest: 'جاهز للاستثمار؟',
        ctaGuide: 'دليل المستثمر',
        languageToggle: 'اللغة',
        languageAr: 'العربية',
        languageEn: 'English',
      },
      home: {
        date: '27 أبريل 2026',
        titleFirst: 'أدفانتج عُمان',
        titleSecond: 'منتدى 2026',
        tagline: 'نشكّل مستقبل الاستثمار',
        heroTitleFirst: 'نشكّل',
        heroTitleSecond: 'مستقبل الاستثمار',
        heroSubtitleLine1: 'انضموا إلينا في نقاشات ثاقبة وفرص تواصل وتجربة مباشرة',
        heroSubtitleLine2: 'لأبرز الفرص الاستثمارية في عُمان.',
        countdownLabels: {
          days: 'أيام',
          hours: 'ساعات',
          minutes: 'دقائق',
          seconds: 'ثواني',
        },
        eventStartedTitle: 'انطلقت الفعالية!',
        eventStartedDescription: 'انضموا إلينا في منتدى الاستثمار في عُمان 2026 لفرص مثيرة وشبكات علاقات جديدة.',
      },
      about: {
        badge: 'أهلاً بكم',
        forumTitle: 'إلى منتدى أدفانتج عُمان',
        loading: 'جارٍ تحميل معلومات المنتدى...',
        error: 'حدث خطأ أثناء تحميل معلومات المنتدى. يرجى المحاولة لاحقاً.',
        attendees: 'الحضور',
        speakers: 'خبراء متحدثون',
        infrastructure: 'البنية التحتية',
        countries: 'الدول',
        statDecisionMakers: 'صناع القرار',
        statGlobalSpeakers: 'متحدثون عالميون',
        statHighValue: 'قيمة عالية',
        statCuratedMeetings: 'اجتماعات منتقاة',
        description: 'انضموا إلينا لنقاشات ثرية، فرص تواصل، وإطلاع مباشر على أبرز الفرص الاستثمارية في عُمان.',
        dateBadge: '27-29 أبريل',
        whoShouldAttendTitle: 'من ينبغي أن يحضر؟',
        whoShouldAttendImageAlt: 'منتدى أدفانتج عُمان — قادة ومستثمرون',
        whoShouldAttend: {
          multinational_corporations: 'الشركات متعددة الجنسيات',
          government_decision_makers: 'صنّاع القرار في القطاع الحكومي',
          sovereign_wealth_funds: 'صناديق الثروة السيادية',
          private_equity_firms: 'شركات الأسهم الخاصة',
          strategic_operators: 'المشغّلون الاستراتيجيون',
          family_offices: 'مكاتب العائلات',
        },
        whoShouldAttendDescription: {
          multinational_corporations:
            'كيانات عالمية تستكشف التوسع في عُمان، بحثًا عن نقاط دخول استراتيجية وشراكات، وإتاحة الوصول إلى قطاعات عالية الإمكانات ضمن مشهد اقتصادي سريع التطور.',
          government_decision_makers:
            'صنّاع سياسات بارزون وقادة في القطاع العام يقودون التنمية الوطنية ويمكّنون الاستثمار، ويسهمون في تشكيل البيئة التنظيمية الداعمة للنمو المستدام.',
          sovereign_wealth_funds:
            'مستثمرون مؤسسيون على المدى الطويل ينخرطون في فرص استراتيجية تتماشى مع رؤية عُمان، مع تركيز على عوائد مستقرة وتنويع وقيمة وطنية.',
          private_equity_firms:
            'قادة استثمار يحدّدون فرصًا قابلة للتوسع عبر القطاعات ذات الأولوية في عُمان، مستفيدين من الشراكات لتسريع النمو وإطلاق القيمة.',
          strategic_operators:
            'جهات صناعية راسخة ومشغّلون يسعون لتوسيع العمليات وتحسين الأداء وبناء تعاونات ذات معنى داخل منظومة عُمان.',
          family_offices:
            'مستثمرون من رأس المال الخاص يبحثون عن فرص متنوعة وطويلة الأجل، وشراكات استثمار مشتركة، ووصول مباشر إلى القطاعات الناشئة والمشاريع الاستراتيجية في عُمان.',
        },
      },
      schedule: {
        badge: 'جدول المنتدى',
        title: 'أجندة المنتدى',
        subtitle: 'استكشفوا برنامجاً منتقى بعناية من الكلمات الرئيسية وحلقات النقاش والجلسات الاستراتيجية المصمّمة لتناول المشهد الاستثماري في عُمان وإبراز القطاعات ذات الأولوية وتعزيز الروابط بين المستثمرين العالميين والجهات الوطنية.',
        loading: 'جارٍ تحميل الجدول...',
        errorPrefix: 'خطأ:',
        noData: 'لا توجد بيانات للجدول',
        dayLabel: 'اليوم',
        eventsLabel: 'فعاليات',
        paginationPrev: 'السابق',
        paginationNext: 'التالي',
        paginationPage: 'صفحة {current} من {total}',
      },
      faceToFace: {
        title: 'لقاءات وجهاً لوجه',
        subtitle:
          'بنية تحتية عالمية المستوى مدعومة بمناطق صناعية واقتصادية وحرة مخصصة لتسريع النمو وتعظيم إمكانات الاستثمار.',
        privateTitle: 'برنامج التفاعل الخاص',
        privateBody:
          'سلسلة منتقاة من التفاعلات الحصرية تربط أصحاب المصلحة الرئيسيين من خلال حوارات مخصصة وتفاعلات عالية القيمة.',
        b2bTitle: 'اجتماعات B2B منظمة',
        b2bBody:
          'اجتماعات مسبقة الترتيب تسهّل الروابط المباشرة بين المستثمرين والشركاء وأصحاب المصلحة لاستكشاف التعاون وفرص الأعمال.',
        govTitle: 'جلسات حوارية حكومية',
        govBody:
          'مناقشات مركّزة مع ممثلين حكوميين كبار تتناول السياسات والتشريعات والمبادرات الاستراتيجية التي تشكّل بيئة الاستثمار في عُمان.',
        sectorTitle: 'إحاطات قطاعية',
        sectorBody:
          'جلسات معمّقة تقدّم رؤى حول القطاعات ذات الأولوية وتسلّط الضوء على الفرص واتجاهات السوق والتطورات الرئيسية عبر الاقتصاد العُماني.',
        imageAlt: 'لقاءات وجهاً لوجه في منتدى ميزة عُمان',
      },
      speakers: {
        badge: 'فريق',
        title: 'متحدثونا',
        subtitle: 'تعرّفوا على قادة الصناعة وصنّاع الرؤى الذين يشكّلون مستقبل الاستثمار في عُمان.',
        loading: 'جارٍ تحميل المتحدثين...',
        errorPrefix: 'خطأ في تحميل المتحدثين:',
        empty: 'لا يوجد متحدثون حالياً.',
        details: 'تفاصيل',
        about: 'نبذة',
        filterAll: 'الكل',
        filterGovernment: 'حكومي',
        filterPrivateSector: 'قطاع خاص',
        filterInternational: 'دولي',
        carouselPrev: 'المتحدث السابق',
        carouselNext: 'المتحدث التالي',
        carouselDot: 'المتحدث {n}',
      },
      sponsors: {
        badge: 'شركاؤنا',
        title: 'الشركاء',
        subtitle: 'بدعم من قادة الصناعة الذين يشاركونا رؤيتنا للابتكار والتقدم.',
        loading: 'جارٍ تحميل شركائنا المميزين...',
        errorPrefix: 'خطأ في تحميل الشركاء:',
        empty: 'لا يوجد شركاء حالياً. ترقّبوا المزيد قريباً!',
        visit: 'زيارة',
        filterAll: 'الكل',
        defaultGroup: 'شركاء',
      },
      whyOman: {
        badge: 'وجهة استثمارية',
        title: 'لماذا عُمان؟',
        subtitle: 'اكتشفوا المزايا الفريدة للاستثمار وممارسة الأعمال في قلب الشرق الأوسط',
        keySectorsTitle: 'القطاعات الرئيسية',
        keySectorsDescription:
          'استكشفوا فرص الاستثمار النابضة في عُمان، عبر قطاعات أساسية مثل التكنولوجيا والطاقة المتجددة واللوجستيات والتصنيع. انضموا إلينا لاكتشاف كيف تزدهر هذه المجالات!',
        exploreAllSectors: 'استكشف جميع القطاعات',
        exploreSector: 'استكشف القطاع',
        sliderPrev: 'القطاع السابق',
        sliderNext: 'القطاع التالي',
        sliderDot: 'الشريحة {n}',
        loading: 'جارٍ تحميل القطاعات الاستثمارية...',
        errorPrefix: 'خطأ في تحميل القطاعات:',
        errorFallback: 'سيتم عرض محتوى بديل مؤقتاً',
        empty: 'لا توجد قطاعات استثمارية حالياً. ترقّبوا المزيد قريباً!',
        overview: 'نظرة عامة',
      },
      whyOmanMap: {
        sectionTitle: 'البنية التحتية',
        sectionSubtitle:
          'بنية تحتية عالمية المستوى مدعومة بمناطق صناعية واقتصادية وحرّة مخصّصة لتسريع النمو وتعظيم إمكانات الاستثمار',
        mapAlt: 'خريطة عُمان مع مواقع مناطق الاستثمار',
        closeAria: 'إغلاق',
        showDetailsFor: 'عرض التفاصيل: {name}',
        markerLocation: '{name}، موقع على الخريطة',
        overviewKpiValue: '$52',
        overviewKpiUnit: 'مليار دولار أمريكي',
        overviewHeadline: 'مستثمر في المناطق الصناعية والاقتصادية والحرّة',
        overviewSecondaryNumber: '22',
        overviewSecondaryHighlight: 'مناطق استراتيجية',
        tabs: {
          overview: 'نظرة عامة',
          industrial: 'المجمعات الصناعية',
          economicFree: 'المناطق الاقتصادية والحرّة',
          tech: 'المتنزّه التقني',
        },
        types: {
          FZ: 'مناطق حرّة',
          IZ: 'مناطق صناعية',
          EZ: 'مناطق اقتصادية',
          IT: 'متنزّهات تكنولوجية',
        },
        left: {
          industrial: {
            kpiValue: 'المجمعات',
            kpiUnit: 'الصناعية',
            headlineLine1: 'تجمعات صناعية مخصّصة',
            headlineLine2: 'لدعم نمو التصنيع',
            secondaryPrefix: 'IZ',
            secondaryHighlight: 'مواقع',
          },
          economicFree: {
            kpiValue: 'مناطق',
            kpiUnit: 'اقتصادية وحرّة',
            headlineLine1: 'وجهات استثمارية',
            headlineLine2: 'بحوافز ووصول مينائي',
            secondaryPrefix: '',
            secondaryHighlight: '',
          },
          tech: {
            kpiValue: 'تقنية',
            kpiUnit: 'متنزّهات',
            headlineLine1: 'مراكز ابتكار لتقنية المعلومات،',
            headlineLine2: 'والشركات الناشئة والبحث والتطوير',
            secondaryPrefix: '',
            secondaryHighlight: '',
          },
        },
        industrialPanel: {
          logoAlt: 'مدائن — المجمعات الصناعية العُمانية',
          aboutTitle: 'نبذة',
          aboutBody:
            'المنطقة الاقتصادية الخاصة بالدقم في محافظة الوسطى تبعد 550 كم عن مسقط. وهي الأكبر في الشرق الأوسط وشمال أفريقيا، وتغطي 2000 كيلومتر مربع.',
          objectivesTitle: 'الأهداف',
          objective1: 'جذب استثمارات أجنبية متزايدة إلى عُمان',
          objective2: 'تعزيز مشاركة القطاع الخاص في النمو الاجتماعي والاقتصادي للبلاد.',
          objective3: 'تعزيز الاستدامة البيئية في الصناعة',
          objective4: 'خلق فرص عمل طويلة الأمد ذات جودة لشباب عُمان',
          stats: {
            investors: 'مستثمرون',
            employees: 'موظفون',
            investments: 'استثمارات',
          },
        },
        markers: {
          '1': { name: 'الموقع 1', highlight: 'وصف 1' },
          '2': { name: 'الموقع 2', highlight: 'وصف 2' },
          '3': { name: 'الموقع 3', highlight: 'وصف 3' },
          '4': {
            name: 'المنطقة الحرة بميناء صحار',
            highlight:
              'تقع على بعد 220 كم من مسقط، وتمتد المنطقة الحرة بصحار على 4500 هكتار في موقع استراتيجي بين مسقط ودبي. ميناء مياه عميقة يتعامل مع أكثر من مليون طن من البضائع أسبوعياً، مع أرصفة تستوعب أكبر السفن.',
          },
          '5': {
            name: 'منطقة خزائن الاقتصادية',
            highlight:
              'المركز المتكامل للتجارة واللوجستيات والصناعة في عُمان. خزائن أكبر منطقة تنمية اقتصادية في نطاق مسقط الكبرى، على طريق مسقط – الباطنة السريع، مع وصول برّي ممتاز إلى عُمان والإمارات والسعودية.',
          },
          '6': { name: 'الموقع 6', highlight: 'وصف 6' },
          '7': {
            name: 'واحة المعرفة مسقط',
            highlight:
              'نستضيف اليوم أكثر من 200 شركة ومؤسسة وتنظيم محلي وإقليمي وعالمي يركّز على المستقبل، من الشركات الصغيرة والمتوسطة الوطنية النامية ومقدمي التعليم العالي إلى الشركات التي تستفيد من منظومة واحة المعرفة.',
          },
          '8': { name: 'الموقع 8', highlight: 'وصف 8' },
          '9': { name: 'الموقع 9', highlight: 'وصف 9' },
          '10': { name: 'الموقع 10', highlight: 'وصف 10' },
          '11': { name: 'الموقع 11', highlight: 'وصف 11' },
          '12': {
            name: 'المنطقة الاقتصادية الخاصة بالدقم',
            highlight:
              'المنطقة الاقتصادية الخاصة بالدقم في محافظة الوسطى تبعد 550 كم عن مسقط. وهي الأكبر في الشرق الأوسط وشمال أفريقيا، وتغطي 2000 كيلومتر مربع.',
          },
          '13': {
            name: 'المنطقة الحرة بالمزيونة',
            highlight:
              'المنطقة الحرة بالمزيونة في محافظة ظفار قرب الحدود اليمنية، بوابة خليجية مهمة للتجارة العابرة إلى اليمن وشرق أفريقيا.',
          },
          '14': { name: 'الموقع 14', highlight: 'وصف 14' },
          '15': {
            name: 'المنطقة الحرة بصلالة',
            highlight:
              'المركز المتكامل للتجارة واللوجستيات والصناعة في عُمان. خزائن أكبر منطقة تنمية اقتصادية في نطاق مسقط الكبرى، على طريق مسقط – الباطنة السريع، مع وصول برّي ممتاز إلى عُمان والإمارات والسعودية.',
          },
        },
      },
      opportunitiesInOman: {
        title: 'فرص في عُمان',
        subtitle:
          'استكشف مشاريع عالية الأثر بما يتماشى مع رؤية 2040 عبر اللوجستيات والتصنيع والطاقة والسياحة والأمن الغذائي والاقتصاد الرقمي.',
        capitalLabel: 'رأس المال',
        exploreCta: 'استكشف المزيد من فرص الاستثمار',
        sliderPrevAria: 'عرض الفرص السابقة',
        sliderNextAria: 'عرض المزيد من الفرص',
        placeholderImageAria: 'معاينة فرصة {n}',
        card1: { name: 'مشروع الجبل الأعلى', sector: 'عقارات', capital: '1,200,000,000 ر.ع.' },
        card2: { name: 'بوابة الأعمال', sector: 'طيران', capital: '260,000,000 ر.ع.' },
        card3: { name: 'شارع ريادة الأعمال – صلالة', sector: 'سياحة', capital: '40,000,000 ر.ع.' },
        card4: {
          name: 'الأمن السيبراني كخدمة للمؤسسات الصغيرة والمتوسطة',
          sector: 'تقنية المعلومات',
          capital: '7,507,500 ر.ع.',
        },
        card5: { name: 'مركز الكشف المبكر', sector: 'رعاية صحية', capital: '7,500,000 ر.ع.' },
        card6: {
          name: 'مشروع تربية الجمبري الضخم في رأس مدركة',
          sector: 'مصائد سمكية',
          capital: '32,000,000 ر.ع.',
        },
      },
      livestream: {
        title: 'البث المباشر',
        subtitle: 'انضم إلينا افتراضياً وعش أجواء الحدث في الوقت الفعلي.',
        watchLive: 'شاهد البث المباشر',
        playVideo: 'تشغيل الفيديو',
      },
      footer: {
        connect: 'تواصل معنا',
        booklet: 'تحميل كتيب أدفانتج عُمان',
        register: 'سجّل لمتابعة البث المباشر في 27 أبريل',
        registerWatchLive: 'سجّل لمشاهدة البث المباشر',
        downloadTitle: 'حمّل تطبيقنا',
        downloadSubtitle: 'تابع الجلسات المباشرة وشارك بالتفاعل الفوري وابقَ متصلاً طوال الحدث.',
        downloadAppStore: 'التنزيل من App Store',
        downloadGooglePlay: 'التنزيل من Google Play',
        tajawobAlt: 'تجاوب',
        omancircleAlt: 'استثمر عُمان',
        contactTitle: 'تواصل معنا',
        contactSubtitle: 'لديك استفسار؟ أرسل طلبك وسنعود إليك قريباً.',
        successTitle: 'تم إرسال الرسالة بنجاح!',
        successDesc: 'سنقوم بالرد عليك في أقرب وقت ممكن.',
        errorPrefix: 'خطأ:',
        nameLabel: 'الاسم',
        emailLabel: 'البريد الإلكتروني',
        messageLabel: 'الرسالة',
        namePlaceholder: 'اكتب اسمك',
        emailPlaceholder: 'you@example.com',
        messagePlaceholder: 'اكتب رسالتك...',
        send: 'إرسال الاستفسار',
        copyright: '© 2026 استثمر في عُمان، جميع الحقوق محفوظة',
        modalTitle: 'سجّل اهتمامك',
        modalThanksTitle: 'شكراً لاهتمامك!',
        modalThanksDesc: 'لقد استلمنا معلوماتك.',
        modalErrorPrefix: 'خطأ:',
        modalNameLabel: 'الاسم',
        modalEmailLabel: 'البريد الإلكتروني',
        modalSubmit: 'تسجيل',
        modalSubmitting: 'جاري الإرسال...',
        startInvesting: 'ابدأ الاستثمار',
        investmentOpportunities: 'فرص الاستثمار',
        sectors: 'القطاعات',
        resourcesTools: 'الموارد والأدوات',
        investorGuide: 'دليل المستثمر',
        businessSimulator: 'محاكي الأعمال',
        licensesSimulator: 'محاكي التراخيص',
        discover: 'اكتشف',
        whyOman: 'لماذا عُمان؟',
        incentives: 'الحوافز',
        reportsPublications: 'التقارير والمنشورات',
        newsAnnouncements: 'الأخبار والإعلانات',
        successStories: 'قصص النجاح',
        faqs: 'الأسئلة الشائعة',
        aboutInvestOman: 'عن استثمر عُمان',
        aboutUs: 'من نحن',
        howCanWeHelp: 'كيف يمكننا المساعدة؟',
        contactUsLink: 'اتصل بنا',
        connectColumn: 'تواصل',
        omanBusinessPlatform: 'منصة الأعمال العُمانية',
        freeZones: 'المناطق الحرة',
        industrialZones: 'المناطق الصناعية',
        needAssistance: 'تحتاج مساعدة؟',
        emailShort: 'البريد:',
        phoneShort: 'الهاتف:',
        assistanceEmail: 'forum@investoman.om',
        assistancePhone: '+968 80000222',
        copyrightBrand: 'حقوق النشر © 2026 InvestOMAN',
        copyrightLine: 'حقوق النشر © 2026 InvestOMAN',
        rightsReserved: 'جميع الحقوق محفوظة',
        termsAndConditions: 'الشروط والأحكام',
        privacyPolicy: 'سياسة الخصوصية',
        appComingSoonTitle: 'قريباً',
        appComingSoonMessage:
          'سيُتاح تطبيق استثمر عُمان على App Store وGoogle Play قريباً. شكراً لاهتمامك.',
        appComingSoonClose: 'إغلاق',
      },
      attend: {
        ctaLabel: 'عبّر عن رغبتك في الحضور',
        title: 'عبّر عن رغبتك في حضور المنتدى',
        subtitle: 'شاركنا بعض التفاصيل ليقوم فريقنا بمراجعة طلبك.',
        fields: {
          name: 'الاسم',
          company: 'الشركة',
          designation: 'المسمى الوظيفي',
          country: 'الدولة',
          sector: 'القطاع محل الاهتمام',
          investmentRange: 'نطاق حجم الاستثمار',
          tourismProgramsHeading: 'البرامج السياحية (اختياري)',
          tourismMuscat: 'حضور برنامج سياحي — جولة مسقط',
          tourismOmanOvernight: 'حضور برنامج سياحي — جولة عُمان (تشمل مبيتاً ليلاً)',
          email: 'البريد الإلكتروني',
          phone: 'جهة الاتصال',
          linkedin: 'حساب لينكدإن',
          website: 'موقع الشركة',
          whyAttend: 'لماذا يجب أن تحضر؟',
          brief: 'نبذة عن شركتك أو سبب رغبتك في الحضور',
          companyCapitalSize: 'حجم رأس مال الشركة',
          seniorityLevel: 'المستوى الوظيفي',
          selectCapital: 'اختر حجم رأس المال',
          selectSeniority: 'اختر المستوى الوظيفي',
        },
        required: 'هذا الحقل مطلوب.',
        validationNameLength: 'يجب أن يكون الاسم بين 3 و 40 حرفاً.',
        validationCompanyLength: 'يجب أن تكون الشركة بين 1 و 35 حرفاً.',
        validationDesignationLength: 'يجب أن يكون المسمى الوظيفي بين 1 و 35 حرفاً.',
        validationSectorLength: 'يجب أن يكون القطاع بين 1 و 35 حرفاً.',
        validationInvestmentLength: 'يجب أن يكون نطاق حجم الاستثمار بين 1 و 35 حرفاً.',
        validationEmail: 'يرجى إدخال بريد إلكتروني صالح.',
        validationPhoneDigits: 'يجب أن يحتوي حقل الاتصال على أرقام فقط.',
        validationWhyAttendLength: 'يجب أن يكون هذا الحقل بين 3 و 1000 حرفاً.',
        validationCapitalRequired: 'يرجى اختيار حجم رأس مال الشركة.',
        validationSeniorityRequired: 'يرجى اختيار المستوى الوظيفي.',
        submitting: 'جاري إرسال الطلب...',
        submit: 'إرسال الطلب',
        successMessage: 'طلبك قيد المراجعة. سيتواصل معك فريقنا قريباً.',
        errorGeneric: 'تعذّر إرسال طلبك. يرجى المحاولة لاحقاً.',
      },
      auth: {
        loginTitle: 'تسجيل الدخول',
        loginSubtitle: 'استخدم حسابك للوصول إلى منصة أدفانتج عُمان.',
        forgotTitle: 'نسيت كلمة المرور',
        forgotSubtitle: 'سيتم إرسال رابط آمن لإعادة تعيين كلمة المرور.',
        emailLabel: 'البريد الإلكتروني',
        passwordLabel: 'كلمة المرور',
        forgotLink: 'نسيت كلمة المرور؟',
        backToSignIn: 'العودة لتسجيل الدخول',
        signInButton: 'تسجيل الدخول',
        signingIn: 'جاري تسجيل الدخول...',
        sendingReset: 'جاري إرسال رابط إعادة التعيين...',
        sendResetButton: 'إرسال رابط إعادة التعيين',
        forgotSuccess: 'في حال كان البريد مسجلاً، سيتم إرسال رابط إعادة التعيين.',
        footerNote: 'وصول آمن للمستخدمين المسجلين.',
        emailRequired: 'يرجى إدخال البريد الإلكتروني.',
        resetErrorGeneric: 'فشل في إرسال رابط إعادة التعيين.',
        loginErrorGeneric: 'فشل تسجيل الدخول. يرجى التحقق من البيانات.',
        checkingSession: 'جاري التحقق من الجلسة...',
      },
    },
    dashboard: {
      loading: 'جارٍ التحميل...',
      title: 'لوحة التحكم',
      adminConsole: 'وحدة المشرف',
      switchToArabic: 'التبديل إلى العربية',
      switchToEnglish: 'التبديل إلى الإنجليزية',
      subtitle: 'إدارة محتوى المنتدى',
      overview: 'نظرة عامة',
      overviewDescription: 'عرض إحصائيات المنتدى والإجراءات السريعة',
      myProfile: 'ملفي الشخصي',
      myProfileDescription: 'إدارة معلوماتك الشخصية والأمان ورمز الاستجابة السريعة.',
      guest: 'ضيف',
      profile: {
        avatarAlt: 'الملف الشخصي',
        changePicture: 'تغيير الصورة',
        removePicture: 'إزالة الصورة',
      },
      profilePersonalInfo: 'المعلومات الشخصية',
      profileTravelDetails: 'تفاصيل السفر',
      profileHotel: 'الفندق',
      profileVisaLetter: 'خطاب التأشيرة',
      profileSecurity: 'الأمان',
      profileDangerZone: 'منطقة الخطر',
      profileEntryPass: 'بطاقة الدخول',
      uniqueAttendeeId: 'المعرف',
      driverName: 'اسم السائق',
      driverContact: 'رقم اتصال السائق',
      notProvided: 'غير متوفر',
      organization: 'الشركة',
      status: 'الحالة',
      editInRegistration: 'تعديل في خطوات التسجيل',
      edit: 'تعديل',
      assignedDriver: 'السائق المعين لك',
      changePassword: 'تغيير كلمة المرور',
      currentPassword: 'كلمة المرور الحالية',
      newPassword: 'كلمة المرور الجديدة',
      confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
      deleteAccount: 'حذف الحساب',
      deleteAccountConfirm: 'هل أنت متأكد من حذف حسابك؟ لا يمكن التراجع عن هذا الإجراء.',
      deleteAccountUnderstand: 'أفهم أن هذا الإجراء نهائي',
      updatePassword: 'تحديث كلمة المرور',
      saving: 'جاري الحفظ...',
      save: 'حفظ',
      close: 'إغلاق',
      select: 'اختر',
      placeholders: {
        fullName: 'مثال: محمد أحمد',
        email: 'example@email.com',
        flightNumber: 'مثال: WY 101',
        hotelName: 'مثال: قصر البستان',
        sponsorName: 'مثال: تنمية نفط عُمان',
        websiteUrl: 'https://company.com',
      },
      filtersApplied: 'تم تطبيق {count} عامل/عوامل تصفية',
      formLabelFullName: 'الاسم الكامل *',
      formLabelOrganization: 'الشركة *',
      formLabelPosition: 'المنصب *',
      formLabelPhone: 'رقم الاتصال *',
      formLabelCode: 'رمز الدولة',
      formLabelNationality: 'الجنسية *',
      formLabelCountry: 'الدولة *',
      formLabelSector: 'القطاع *',
      profileFields: {
        companyCapital: 'حجم رأس مال الشركة',
        seniorityLevel: 'المستوى الوظيفي',
        capital1_5m: '1–5 مليون دولار أمريكي',
        capital5_10m: '5–10 مليون دولار أمريكي',
        capitalAbove10m: 'أكثر من 10 مليون دولار أمريكي',
        seniorityCSuite: 'الإدارة العليا (C-Suite)',
        seniorityExecutive: 'القيادة التنفيذية',
        seniorityGovernment: 'القيادة الحكومية',
        selectPlaceholder: 'اختر…',
        errorCapitalRequired: 'يرجى اختيار حجم رأس المال.',
        errorSeniorityRequired: 'يرجى اختيار المستوى الوظيفي.',
      },
      profileUpdatedSuccess: 'تم تحديث الملف الشخصي بنجاح.',
      travelSavedSuccess: 'تم حفظ تفاصيل السفر.',
      hotelSavedSuccess: 'تم حفظ تفاصيل الفندق.',
      visaSavedSuccess: 'تم حفظ تفاصيل خطاب التأشيرة.',
      passwordChangedSuccess: 'تم تغيير كلمة المرور بنجاح.',
      pictureUpdatedSuccess: 'تم تحديث صورة الملف الشخصي.',
      pictureRemovedSuccess: 'تم إزالة صورة الملف الشخصي.',
      removePictureConfirm: 'إزالة صورة الملف الشخصي؟',
      updatingAvatar: 'جاري التحديث',
      securityDescription: 'حافظ على أمان حسابك باستخدام كلمة مرور قوية وفريدة.',
      dangerDescription: 'بمجرد حذف حسابك، لا يمكن التراجع. سيتم حذف جميع بياناتك نهائياً.',
      errorUpdateProfile: 'فشل تحديث الملف الشخصي.',
      errorDeleteAccount: 'فشل حذف الحساب.',
      errorLoadProfile: 'فشل تحميل تفاصيل الملف الشخصي.',
      errorPictureTooBig: 'حجم الصورة كبير جداً. يرجى اختيار صورة أصغر.',
      errorPictureFailed: 'فشل رفع الصورة. يرجى المحاولة مرة أخرى.',
      errorRemovePicture: 'فشل إزالة صورة الملف الشخصي.',
      errorSave: 'فشل الحفظ.',
      errorPasswordLength: 'يجب أن تتكون كلمة المرور الجديدة من 6 أحرف على الأقل.',
      errorPasswordMismatch: 'كلمات المرور الجديدة غير متطابقة.',
      programs: 'البرامج',
      programsDescription: 'إضافة وإدارة البرامج',
      programsPage: {
        noMatch: 'لا توجد برامج تطابق عوامل التصفية المحددة.',
        noMatchHint: 'جرّب تغيير التاريخ أو فلتر الجمهور.',
        filters: {
          date: 'التاريخ',
          allDates: 'كل التواريخ',
          audience: 'الجمهور',
        },
        form: {
          fixErrors: 'يرجى تصحيح أخطاء النموذج قبل الحفظ.',
        },
      },
      schedule: 'الجدول الزمني',
      scheduleDescription: 'تحديث جدول الفعالية والجلسات',
      schedulePage: {
        loading: 'جارٍ تحميل الجدول...',
        noEventsForDay: 'لا توجد فعاليات لليوم {day}',
        noEventsHint: 'جرّب يومًا آخر أو أضف فعالية.',
        dayOption: 'اليوم {day}',
      },
      meetingRooms: 'غرف الاجتماعات',
      meetingRoomsDescription: 'حجز وإدارة حجوزات غرف الاجتماعات',
      speakers: 'المتحدثون',
      speakersDescription: 'إضافة أو تعديل ملفات المتحدثين',
      searchSpeakers: 'ابحث عن المتحدثين بالاسم أو الشركة أو النوع أو الدولة',
      speakersPage: {
        loading: 'جارٍ تحميل المتحدثين...',
        filters: {
          allTypes: 'كل الأنواع',
        },
        validation: {
          nameLength: 'يجب أن يكون اسم المتحدث بين 3 و 35 حرفاً.',
          positionLength: 'يجب أن يكون المنصب بين 3 و 35 حرفاً.',
          companyLength: 'يجب أن تكون الجهة بين 3 و 25 حرفاً.',
          bioMax: 'لا يمكن أن تتجاوز السيرة 1500 حرفاً.',
        },
        form: {
          namePlaceholder: 'أدخل الاسم الكامل',
          positionPlaceholder: 'المسمى الوظيفي / الدور',
          companyPlaceholder: 'الجهة / المؤسسة',
          selectCountry: 'اختر الدولة',
          speakerType: 'نوع المتحدث',
          linkedinPlaceholder: 'https://linkedin.com/in/username',
          shortDescription: 'وصف مختصر',
          bioLabel: 'السيرة',
          charCount: '{current} / {max}',
          bioPlaceholder: 'نبذة قصيرة عن المتحدث والمواضيع الأساسية والإنجازات...',
          portraitTitle: 'صورة المتحدث',
          portraitSubtitle: 'ارفع صورة واضحة ومربعة. سيتم استخدامها في التطبيق.',
          uploadPhoto: 'انقر لرفع الصورة',
        },
        types: {
          government: 'حكومي',
          privateSector: 'قطاع خاص',
          international: 'دولي',
        },
      },
      sponsors: 'الرعاة',
      sponsorsDescription: 'إدارة شعارات ومعلومات الرعاة',
      sponsorsPage: {
        validation: {
          nameLength: 'يجب أن يكون اسم الراعي بين 3 و 45 حرفاً.',
          logoRequired: 'شعار الراعي مطلوب.',
          logoPngOnly: 'يجب أن يكون الشعار بصيغة PNG (.png).',
        },
        searchPlaceholder: 'ابحث بالاسم أو الموقع…',
        partnerType: 'نوع الشريك',
        allTypes: 'كل الأنواع',
        loading: 'جارٍ تحميل الرعاة...',
        noMatch: 'لا يوجد رعاة يطابقون عوامل التصفية المحددة.',
        noMatchHint: 'جرّب بحثًا مختلفًا أو نوع شريك آخر.',
        visitWebsite: 'زيارة الموقع',
        noWebsite: 'لا يوجد رابط',
        uploadLogo: 'رفع الشعار',
        pngOnlyHint: 'PNG فقط (مطلوب)',
        partnerTypes: {
          strategic: 'شريك استراتيجي',
          sector: 'شركاء القطاعات',
          media: 'شركاء الإعلام',
        },
      },
      attendance: 'الحضور',
      attendanceDescription: 'تتبع وإدارة حضور الفعالية',
      attendanceLoadError: 'فشل تحميل سجلات الحضور.',
      attendanceLoading: 'جارٍ تحميل الحضور…',
      attendanceUniqueGuests: 'ضيوف فريدون سجّلوا الحضور',
      attendanceTotalScans: 'إجمالي عمليات مسح الدخول',
      attendanceScanUniqueness: 'نسبة تفرّد عمليات المسح',
      attendanceCheckInColumn: 'تسجيل الدخول',
      refresh: 'تحديث',
      payments: {
        navLabel: 'المدفوعات',
        title: 'سجلات المدفوعات',
        subtitle: 'عرض وإدارة جميع معاملات الدفع من ثواني.',
        anonymousUser: 'مستخدم مجهول',
        totalRevenue: 'إجمالي الإيرادات',
        searchPlaceholder: 'ابحث بالاسم أو البريد أو رقم الدفع أو الحالة...',
        loading: 'جارٍ تحميل سجل المدفوعات...',
        empty: 'لا توجد سجلات مدفوعات مطابقة لبحثك.',
        errors: {
          loadFailed: 'فشل تحميل المدفوعات.',
        },
        filters: {
          status: 'الحالة',
          all: 'الكل',
        },
        status: {
          completed: 'مكتمل',
          pending: 'قيد الانتظار',
          failed: 'فشل',
          refunded: 'تمت الاستعادة',
          unknown: 'غير معروف',
        },
        records: {
          one: 'سجل',
          many: 'سجلات',
        },
        fields: {
          session: 'الجلسة',
          payment: 'الدفع',
          method: 'الطريقة',
        },
      },
      applicants: {
        title: 'طلبات الاهتمام',
        description: 'مراجعة وإدارة المتقدمين الذين أبدوا اهتمامهم بالحضور عبر الصفحة الرئيسية.',
        add: 'إضافة متقدم',
        added: 'تمت الإضافة',
        notesSaved: 'تم حفظ الملاحظات',
        empty: 'لا يوجد متقدمون.',
        manualAddTitle: 'إضافة متقدم',
        manualAddSubtitle: 'إنشاء ملف مستخدم جديد يدوياً',
        autoPassword: 'توقع كلمة المرور التلقائية',
        creating: 'جاري الإنشاء...',
        createProfile: 'إنشاء ملف المتقدم',
        userCreated: 'تم إنشاء المستخدم بنجاح.',
        tempPassword: 'كلمة المرور المؤقتة',
        savePasswordNow: 'احفظ كلمة المرور الآن.',
        errors: {
          loadApplicants: 'فشل تحميل المتقدمين',
          updateStatus: 'فشل تحديث الحالة',
          saveNotes: 'فشل حفظ الملاحظات',
          nameLength: 'يجب أن يكون الاسم بين 3 و35 حرفاً.',
          invalidEmail: 'يرجى إدخال بريد إلكتروني صحيح.',
        },
        filters: {
          status: 'الحالة',
          allStatuses: 'جميع الحالات',
          country: 'الدولة',
          allCountries: 'جميع الدول',
          sector: 'القطاع',
          allSectors: 'جميع القطاعات',
        },
        countOne: 'متقدم',
        countMany: 'متقدمين',
        labels: {
          personalInfo: 'المعلومات الشخصية والمهنية',
          investmentDetails: 'القطاع والسياحة',
          motivation: 'الدافع والسبب',
          adminNotes: 'ملاحظات إدارية داخلية',
          notesPlaceholder: 'أضف ملاحظات داخلية حول هذا المتقدم...',
          saveNotes: 'حفظ الملاحظات',
          saving: 'جاري الحفظ...',
          submittedOn: 'تم التقديم في',
          lastUpdated: 'آخر تحديث في',
          noReason: 'لم يتم تقديم سبب.',
          searchPlaceholder: 'البحث عن المتقدمين...'
        },
        statuses: {
          under_review: 'قيد المراجعة',
          approved: 'مقبول',
          rejected: 'مرفوض',
          waitlisted: 'على قائمة الانتظار'
        }
      },
      applicantSetup: {
        loading: 'جارٍ تحميل إعداد المتقدم...',
        title: 'تهيئة المتقدم',
        subtitle: 'أكمل ملفك الشخصي ثم أرسل دفع المقعد.',
        steps: {
          profile: 'بيانات الملف',
          payment: 'دفع المقعد',
        },
        selectNationality: 'اختر الجنسية',
        selectCountry: 'اختر الدولة',
        payment: {
          title: 'دفع المقعد',
          subtitle: 'اختر فئة المقعد وأكمل الدفع.',
          seatTier: 'فئة المقعد',
          tier: {
            standard: 'عادي - 50 ريال عماني',
            vip: 'كبار الشخصيات - 60 ريال عماني',
            partner: 'تخصيص شريك - 60 ريال عماني',
          },
          cardHolder: 'اسم حامل البطاقة',
          cardNumber: 'رقم البطاقة',
          expiry: 'الانتهاء (MM/YY)',
          cvv: 'CVV',
          backToProfile: 'العودة للملف',
          processing: 'جارٍ المعالجة...',
          submit: 'إرسال الدفع',
        },
      },
      guests: 'الضيوف',
      guestsDescription: 'إدارة ضيوف وتسجيلات الفعالية',
      guestsPage: {
        loading: 'جارٍ تحميل المستخدمين...',
        allDates: 'كل التواريخ',
        idLabel: 'المعرّف',
        invitation: 'الدعوة',
        rsvp: 'تأكيد الحضور',
        restore: 'استعادة',
        roleChangeSuperAdminOnly: 'فقط المشرف الأعلى يمكنه تغيير دور هذا المستخدم.',
      },
      livestream: 'البث المباشر',
      livestreamDescription: 'إدارة إعدادات وعناوين البث المباشر',
      logisticsInfo: 'معلومات اللوجستيات',
      logisticsInfoDescription: 'عرض تفاصيل السفر والفندق والتأشيرة لجميع الحضور المسجلين.',
      logisticsPage: {
        summary: {
          attendees: 'الحضور',
          flightsIssued: 'التذاكر الصادرة',
          hotelsAssigned: 'الفنادق المعيّنة',
          visaReady: 'التأشيرة جاهزة',
        },
        searchPlaceholder: 'ابحث بالاسم أو البريد أو رقم الرحلة…',
        empty: 'لم يتم العثور على تفاصيل السفر.',
        errors: {
          loadFailed: 'فشل التحميل.',
          saveFailed: 'فشل حفظ التغييرات.',
          uploadFailed: 'فشل الرفع.',
          fileType: 'يرجى رفع ملف PDF أو صورة.',
          fileTooLarge: 'الملف كبير جداً. الحد الأقصى 10MB.',
        },
        validation: {
          flightNumber: 'رقم الرحلة مطلوب (من 1 إلى 10 أحرف).',
          flightDatesRequired: 'تاريخ الوصول والمغادرة مطلوبان عندما تكون الرحلة صادرة.',
          arrivalNotPast: 'لا يمكن أن يكون تاريخ الوصول في الماضي.',
          departureNotPast: 'لا يمكن أن يكون تاريخ المغادرة في الماضي.',
          hotelNameMax: 'اسم الفندق لا يتجاوز 35 حرفاً.',
          hotelCheckoutAfterCheckin: 'تاريخ الخروج يجب أن يكون بعد تاريخ الدخول.',
          visaFullNameMax: 'الاسم الكامل لا يتجاوز 35 حرفاً.',
          visaPassportMax: 'رقم الجواز لا يتجاوز 25 حرفاً.',
          visaRequiredFields: 'الاسم الكامل وجواز السفر مطلوبان عندما يكون خطاب التأشيرة مطلوباً.',
        },
        pills: {
          flight: 'رحلة',
          noFlight: 'لا توجد رحلة',
          hotel: 'فندق',
          noHotel: 'لا يوجد فندق',
          visaPrefix: 'تأشيرة',
        },
        filters: {
          allCountries: 'جميع الدول',
          allSectors: 'جميع القطاعات',
          vipOnly: 'كبار الشخصيات فقط',
          nonVip: 'غير كبار الشخصيات',
          complete: 'مكتمل',
          needsAttention: 'بحاجة لمتابعة',
          noneApplied: 'لا توجد عوامل تصفية',
          reset: 'إعادة التعيين',
        },
        flight: {
          title: 'الرحلة',
          issuedLabel: 'صادر',
          issued: 'صادر',
          notIssued: 'غير صادر',
          flightNumber: 'رقم الرحلة',
          arrivalDate: 'تاريخ الوصول',
          arrivalTime: 'وقت الوصول',
          departureDate: 'تاريخ المغادرة',
          departureTime: 'وقت المغادرة',
        },
        hotel: {
          title: 'الفندق',
          statusLabel: 'الحالة',
          assigned: 'مُعيَّن',
          notAssigned: 'غير مُعيَّن',
          name: 'الاسم',
          checkInShort: 'دخول',
          checkOutShort: 'خروج',
          checkIn: 'تاريخ الدخول',
          checkOut: 'تاريخ الخروج',
        },
        visa: {
          title: 'خطاب التأشيرة',
          requiredLabel: 'مطلوب',
          issuedLabel: 'صادر',
          required: 'مطلوب',
          notRequiredLower: 'غير مطلوب',
          notRequired: 'غير مطلوب',
          issued: 'صادر',
          notIssued: 'غير صادر',
          pending: 'قيد الانتظار',
          fullName: 'الاسم الكامل',
          passport: 'جواز السفر',
          requestInfo: 'بيانات الطلب',
          viewIssued: 'عرض الخطاب الصادر',
          viewDocument: 'عرض الملف',
          update: 'تحديث خطاب التأشيرة',
          upload: 'رفع خطاب التأشيرة',
          processing: 'جارٍ معالجة الرفع...',
          uploadSuccess: 'تم رفع خطاب التأشيرة بنجاح.',
        },
        notes: {
          title: 'ملاحظات داخلية',
          optionalHint: '(اختياري، حتى {max} حرفاً)',
          placeholder: 'أضف أي ملاحظات داخلية عن لوجستيات هذا الحضور أو تفضيلاته أو ترتيبات خاصة...',
        },
        detail: {
          titleFallback: 'تفاصيل الحضور',
        },
      },
      paymentsDescription: 'عرض وتتبع جميع مدفوعات التسجيل وسجل المعاملات.',
      analytics: 'التحليلات',
      analyticsDescription: 'عرض الدول والسفر الوارد ورأس مال المستثمرين وتوزيع القطاعات.',
      analyticsPage: {
        loading: 'جارٍ تحميل التحليلات...',
        live: 'بيانات مباشرة',
        subtitle: 'نظرة شاملة على الحضور واللوجستيات والقطاعات.',
        errors: {
          load: 'فشل تحميل بيانات التحليلات.',
        },
        labels: {
          unspecified: 'غير محدد',
          unknown: 'غير معروف',
        },
        inbound: {
          international: 'دولي',
          local: 'محلي (عُمان)',
          localShort: 'محلي',
        },
        kpis: {
          totalAttendees: 'إجمالي الحضور',
          countries: 'الدول',
          vip: 'كبار الشخصيات',
          flightsIssued: 'التذاكر الصادرة',
          payments: 'المدفوعات',
          investorOne: 'مستثمر',
          investorMany: 'مستثمرين',
          international: 'دولي',
          ofAttendees: 'من الحضور',
          total: 'الإجمالي',
          noPayments: 'لا توجد بيانات مدفوعات',
        },
        charts: {
          countries: 'توزيع الدول',
          top: 'أعلى',
          countriesWord: 'دول',
          outOf: 'من أصل',
          inbound: 'الدولي مقابل المحلي',
          inboundSubtitle: 'مسافرون دوليون مقابل المقيمين في عُمان',
          sectors: 'توزيع القطاعات',
          sectorsRepresented: 'قطاعات ممثلة',
          roles: 'توزيع الأدوار',
          rolesSubtitle: 'توزيع أدوار الحضور',
        },
        empty: {
          generic: 'لا توجد بيانات متاحة',
          countries: 'لا توجد بيانات للدول',
          sectors: 'لا توجد بيانات للقطاعات',
          roles: 'لا توجد بيانات للأدوار',
        },
        travelStatus: {
          title: 'حالة السفر واللوجستيات',
          subtitle: '{count} سجل/سجلات سفر',
          pending: 'قيد الانتظار',
          bars: {
            flightsIssued: 'التذاكر الصادرة',
            hotelsAssigned: 'الفنادق المعيّنة',
            visaIssued: 'التأشيرة الصادرة',
            pickupReady: 'الاستلام جاهز',
          },
          cards: {
            flights: 'الرحلات',
            hotels: 'الفنادق',
            visa: 'التأشيرة',
            pickup: 'الاستلام',
          },
        },
        registrationProgress: {
          title: 'تقدم التسجيل',
          subtitle: 'اكتمال الملف والدعوة وتأكيد الحضور',
          completed: 'مكتمل {count}',
          remaining: 'متبقٍ {count}',
        },
        arrivalTimeline: {
          title: 'الجدول الزمني للوصول',
          subtitle: 'الوصول المتوقع حسب التاريخ',
          arrivalsLabel: '{count} وصول',
        },
        investorCapital: {
          title: 'رأس مال المستثمرين',
          subtitle: 'رأس المال المُجمع من حضور المستثمرين',
          badge: 'رأس مال المستثمرين',
          shareOfTotal: 'نسبة من إجمالي المدفوعات',
          totalPayments: 'إجمالي المدفوعات',
          transactions: 'المعاملات',
        },
        paymentCategories: {
          title: 'فئات الدفع',
          subtitle: 'الإيراد حسب نوع التذكرة',
        },
      },
      seatAllocationDescription: 'خريطة مقاعد على طراز المسرح مع فئات ملونة وتصدير PDF',
      manageDownloadGuide: 'إدارة دليل المستثمر والكتيب',
      downloadGuide: 'دليل المستثمر والكتيب',
      downloadGuideDescription: 'إدارة ملف دليل المستثمر القابل للتحميل المستخدم في شريط التنقل وكتيب أدفانتج عُمان في التذييل',
      alert: 'تنبيه',
      alertDescription: 'إرسال تنبيه لجميع المستخدمين',
      backToHome: 'العودة للصفحة الرئيسية',
      home: 'الرئيسية',
      logout: 'تسجيل الخروج',
      welcome: 'مرحباً بعودتك',
      subtitleDescription: 'إدارة المتحدثين والرعاة والجدول الزمني والبث المباشر والمزيد في مركز تحكم موحد وحديث مصمم خصيصاً لتجربة Advantage Oman.',
      addCourse: 'إضافة برنامج',
      editCourse: 'تعديل برنامج',
      startTime: 'وقت البداية',
      endTime: 'وقت النهاية',
      capacity: 'السعة',
      clickToAddFirstProgram: 'انقر على زر + لإضافة برنامجك الأول',
      clickToAddFirstMeetingRoom: 'انقر على زر + لإضافة غرفة الاجتماعات الأولى',
      clickToAddFirstGuest: 'انقر على زر + لإضافة ضيفك الأول',
      deleteGuestConfirm: 'هل أنت متأكد من أنك تريد حذف هذا الضيف؟',
      guestDeleted: 'تم حذف الضيف بنجاح',
      guestAdded: 'تم إضافة الضيف بنجاح',
      guestUpdated: 'تم تحديث الضيف بنجاح',
      noGuestsFound: 'لم يتم العثور على ضيوف',
      titleMaxLength: 'لا يمكن أن يتجاوز العنوان 100 حرف',
      subtitleMaxLength: 'لا يمكن أن يتجاوز العنوان الفرعي 100 حرف',
      locationMaxLength: 'لا يمكن أن يتجاوز الموقع 100 حرف',
      attendanceInfoMaxLength: 'لا يمكن أن تتجاوز معلومات الحضور 100 حرف',
      chatEnabled: 'تم تفعيل ميزة الدردشة',
      chatDisabled: 'تم تعطيل ميزة الدردشة',
      livestreamSaved: 'تم حفظ إعدادات البث المباشر بنجاح.',
      editForumOverview: 'تعديل نظرة عامة على المنتدى',
      mainTitle: 'العنوان الرئيسي',
      subTitle: 'العنوان الفرعي',
      startDate: 'تاريخ البداية',
      endDate: 'تاريخ النهاية',
      location: 'الموقع',
      attendanceInfo: 'معلومات الحضور',
      userRole: 'دور المستخدم',
      allUsers: 'كل المستخدمين',
      user: 'مستخدم',
      delegate: 'مندوب',
      saveChanges: 'حفظ التغييرات',
      dismiss: 'إغلاق',
      titleRequired: 'العنوان مطلوب',
      startDateAfterEndDate: 'لا يمكن أن يكون تاريخ البداية بعد تاريخ النهاية',
      pleaseFixErrors: 'يرجى إصلاح الأخطاء قبل الحفظ',
      manageSchedule: 'إدارة الجدول الزمني',
      addEvent: 'إضافة حدث',
      editEvent: 'تعديل حدث',
      deleteEvent: 'حذف حدث',
      eventName: 'اسم الحدث',
      eventDescription: 'وصف الحدث',
      day: 'اليوم',
      deleteEventConfirm: 'هل أنت متأكد من أنك تريد حذف هذا الحدث؟',
      eventAdded: 'تم إضافة الحدث بنجاح!',
      eventUpdated: 'تم تحديث الحدث بنجاح!',
      eventDeleted: 'تم حذف الحدث بنجاح!',
      noEventsYet: 'لم تتم إضافة أي أحداث بعد',
      tapToAddEvents: 'اضغط على زر + لإضافة الأحداث',
      manageSpeakers: 'إدارة المتحدثين',
      addSpeaker: 'إضافة متحدث',
      addNewSpeaker: 'إضافة متحدث جديد',
      editSpeaker: 'تعديل متحدث',
      deleteSpeaker: 'حذف متحدث',
      speakerName: 'اسم المتحدث',
      position: 'المنصب',
      company: 'الشركة',
      bio: 'السيرة الذاتية',
      deleteSpeakerConfirm: 'هل أنت متأكد من أنك تريد حذف هذا المتحدث؟',
      male: 'ذكر',
      female: 'أنثى',
      speakerAdded: 'تم إضافة المتحدث بنجاح!',
      speakerUpdated: 'تم تحديث المتحدث بنجاح!',
      speakerDeleted: 'تم حذف المتحدث بنجاح!',
      noSpeakersYet: 'لم تتم إضافة أي متحدثين بعد',
      tapToAddSpeakers: 'اضغط على زر + لإضافة المتحدثين',
      manageSponsors: 'إدارة الرعاة',
      addSponsor: 'إضافة راعي',
      addNewSponsor: 'إضافة راعي جديد',
      editSponsor: 'تعديل راعي',
      deleteSponsor: 'حذف راعي',
      sponsorName: 'اسم الراعي',
      sponsorLogo: 'شعار الراعي',
      website: 'الموقع الإلكتروني',
      deleteSponsorConfirm: 'هل أنت متأكد من أنك تريد حذف هذا الراعي؟',
      sponsorAdded: 'تم إضافة الراعي بنجاح!',
      sponsorUpdated: 'تم تحديث الراعي بنجاح!',
      sponsorDeleted: 'تم حذف الراعي بنجاح!',
      noSponsorsYet: 'لم تتم إضافة أي رعاة بعد',
      tapToAddSponsors: 'اضغط على زر + لإضافة الرعاة',
      manageLivestream: 'إدارة البث المباشر',
      streamStatus: 'حالة البث',
      livestreamStatus: 'حالة البث المباشر',
      live: 'مباشر',
      offline: 'غير متصل',
      streamInformation: 'معلومات البث',
      youtubeUrl: 'رابط يوتيوب',
      enterYoutubeUrl: 'أدخل رابط البث المباشر على يوتيوب',
      appLink: 'رابط التطبيق',
      enterAppLink: 'أدخل رابط التطبيق (اختياري)',
      manageGuests: 'إدارة الضيوف',
      addGuest: 'إضافة ضيف',
      updateGuest: 'تحديث ضيف',
      fullName: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      username: 'اسم المستخدم',
      role: 'الدور',
      attendanceRecords: 'سجلات الحضور',
      present: 'حاضر',
      total: 'الإجمالي',
      rate: 'المعدل',
      country: 'الدولة',
      sector: 'القطاع',
      vip: 'كبار الشخصيات',
      investor: 'مستثمر',
      investorTypes: {
        typeLabel: 'نوع المستثمر',
        overseas: 'مستثمر من الخارج',
        omani: 'مستثمر عُماني',
        expatInOman: 'مستثمر في عُمان (وافد)',
        selectPlaceholder: 'اختر نوع المستثمر…',
        errorRequired: 'يرجى اختيار نوع المستثمر عند تفعيل خيار المستثمر.',
      },
      arrivalDate: 'تاريخ الوصول',
      all: 'الكل',
      yes: 'نعم',
      no: 'لا',
      absent: 'غير حاضر',
      checkedIn: 'تم التسجيل',
      searchAttendees: 'البحث عن الحضور...',
      noRecordsFound: 'لم يتم العثور على سجلات حضور',
      name: 'الاسم',
      description: 'الوصف',
      date: 'التاريخ',
      time: 'الوقت',
      add: 'إضافة',
      delete: 'حذف',
      cancel: 'إلغاء',
      confirm: 'تأكيد',
      nameRequired: 'الاسم مطلوب',
      descriptionRequired: 'الوصف مطلوب',
      fillRequiredFields: 'يرجى ملء جميع الحقول المطلوبة',
      comingSoon: 'قريباً',
      gender: 'الجنس',
      positionRequired: 'المنصب مطلوب',
      companyRequired: 'الشركة مطلوبة',
      nameMaxLength: 'لا يمكن أن يتجاوز الاسم 100 حرف',
      linkRequired: 'رابط الموقع مطلوب',
      linkMaxLength: 'لا يمكن أن يتجاوز الرابط 500 حرف',
      linkInvalid: 'يجب أن يبدأ الرابط بـ http:// أو https://',
      logoRequired: 'شعار الراعي مطلوب',
      overviewSaved: 'تم حفظ النظرة العامة بنجاح',
      fileName: 'اسم الملف',
      fileNamePlaceholder: 'دليل المستثمر أدفانتج عُمان 2026 (PDF)',
      fileUrl: 'رابط الملف',
      fileNameRequired: 'اسم الملف مطلوب',
      fileUrlRequired: 'رابط الملف مطلوب',
      fileUrlInvalid: 'يجب أن يبدأ الرابط بـ http:// أو https://',
      downloadGuideSaved: 'تم تحديث دليل المستثمر بنجاح!',
      currentGuidePreview: 'الرابط العام الحالي',
      currentGuideHelper: 'يتم استخدام هذا الرابط في زر "دليل المستثمر" في شريط التنقل وزر "تحميل كتيب أدفانتج عُمان" في التذييل.',
      noGuideConfigured: 'لم يتم إعداد أي دليل بعد. أضف رابط الملف واحفظ لتفعيل أزرار التحميل على الموقع.',
      downloadGuideNote: 'الصق رابطاً عاماً لملف الـ PDF (من تخزين Supabase أو شبكة التوزيع الخاصة بك). سيتم استخدام هذا الرابط في الموقع.',
      downloadGuideInfoTitle: 'أين يتم استخدام هذا؟',
      downloadGuideInfoNav: 'زر شريط التنقل الرئيسي: "دليل المستثمر".',
      downloadGuideInfoFooter: 'زر التذييل: "تحميل كتيب أدفانتج عُمان".',
      downloadGuideVisitorsHint: 'سيقوم الزوار بتحميل هذا الملف عند النقر على أزرار "دليل المستثمر" أو "الكتيّب".',
      displayName: 'اسم العرض',
      viewDocument: 'عرض الملف',
      download: 'تحميل',
      redirecting: 'جارٍ التحويل...',
      fileUpload: 'رفع ملف PDF',
      deleteProgramConfirm: 'هل أنت متأكد من أنك تريد حذف هذا البرنامج؟',
      programDeleted: 'تم حذف البرنامج بنجاح',
      programSaved: 'تم حفظ البرنامج بنجاح',
      noProgramsAvailable: 'لا توجد برامج متاحة',
      meetingRoomManagement: {
        addNewRoom: 'إضافة غرفة اجتماعات جديدة',
        editRoom: 'تعديل غرفة الاجتماعات',
        roomNameRequired: 'اسم الغرفة*',
        amenities: 'المرافق',
        amenitiesPlaceholder: 'بروجكتور، سبورة، مكالمة فيديو...',
        capacity: 'السعة',
        capacityAny: 'أي سعة',
        capacity1to25: '1–25',
        capacity25to50: '25–50',
        capacity50to75: '50–75',
        capacity75plus: '75 فأكثر',
        searchPlaceholder: 'ابحث باسم الغرفة أو الموقع أو الوصف…',
        loading: 'جارٍ تحميل غرف الاجتماعات...',
        noMatch: 'لا توجد غرف تطابق عوامل التصفية المحددة.',
        noMatchHint: 'جرّب بحثًا مختلفًا أو نطاق سعة آخر.',
        enterRoomName: 'يرجى إدخال اسم الغرفة',
        loginRequired: 'يجب تسجيل الدخول لإضافة غرفة',
        addSuccess: 'تم إضافة غرفة الاجتماعات بنجاح',
        addError: 'فشل في إضافة غرفة الاجتماعات',
        updateSuccess: 'تم تحديث غرفة الاجتماعات بنجاح',
        updateError: 'فشل في تحديث غرفة الاجتماعات',
        confirmDeleteTitle: 'تأكيد الحذف',
        confirmDeleteMessage: 'هل أنت متأكد من أنك تريد حذف غرفة الاجتماعات هذه؟',
        deleteSuccess: 'تم حذف غرفة الاجتماعات بنجاح',
        deleteError: 'فشل في حذف غرفة الاجتماعات',
        fetchError: 'فشل في تحميل غرف الاجتماعات',
        noRooms: 'لم تتم إضافة أي غرف اجتماعات بعد',
      },
      users: 'المستخدمون',
      admins: 'المديرون',
      delegates: 'المندوبون',
      checkInStaff: 'طاقم التسجيل',
      vendors: 'الموردون',
      media: 'الإعلام',
      superAdmin: {
        chatManagement: 'إدارة ميزة الدردشة',
        chatDescription: 'تفعيل أو تعطيل ميزات الدردشة الاختيارية',
        chatFeature: 'ميزة الدردشة',
        enabled: 'مفعّل',
        disabled: 'معطّل',
        dangerZone: 'منطقة الخطر',
        resetDescription: 'إعادة تعيين التطبيق بالكامل إلى الإعدادات الافتراضية. سيؤدي هذا إلى:',
        deleteEventData: 'حذف جميع بيانات الفعالية',
        resetColors: 'إعادة تعيين الألوان إلى الافتراضي',
        logoutApp: 'تسجيل خروجك من التطبيق',
        resetButton: 'إعادة تعيين التطبيق إلى الافتراضي',
        resetting: 'جاري إعادة التعيين',
        resetAlert: {
          message: 'سيؤدي هذا إلى حذف جميع بيانات الفعالية والحجوزات وسجلات الحضور وحسابات المستخدمين بشكل دائم. لا يمكن التراجع عن هذا الإجراء!',
        },
        resetSuccess: {
          message: 'تم إعادة تعيين النظام إلى الإعدادات الافتراضية.',
        },
      },
      profileSetup: {
        title: 'أكمل ملفك الشخصي',
        subtitle: 'يرجى إكمال بيانات ملفك الشخصي قبل المتابعة.',
        searchPlaceholder: 'بحث...',
        loading: 'جاري تحميل الملف الشخصي...',
        fullName: 'الاسم الكامل *',
        email: 'البريد الإلكتروني',
        designation: 'المسمى الوظيفي',
        company: 'الشركة',
        nationality: 'الجنسية *',
        country: 'الدولة *',
        phone: 'رقم الاتصال *',
        sector: 'القطاع *',
        selectCountry: 'اختر الدولة',
        selectNationality: 'اختر الجنسية',
        saving: 'جاري الحفظ...',
        saveAndContinue: 'حفظ ومتابعة',
        completeProfile: 'إكمال الملف الشخصي',
        errorFullName: 'الاسم الكامل مطلوب (3-35 حرفاً).',
        errorDesignation: 'المسمى الوظيفي مطلوب (1-30 حرفاً).',
        errorCompany: 'الشركة مطلوبة (1-40 حرفاً).',
        errorNationality: 'الجنسية مطلوبة (3-25 حرفاً).',
        errorCountry: 'الدولة مطلوبة.',
        errorCountryCode: 'يرجى اختيار رمز دولة صحيح.',
        errorPhone: 'رقم الاتصال مطلوب ويجب أن يكون أرقاماً فقط (حتى 10 أرقام).',
        errorSector: 'القطاع مطلوب (1-45 حرفاً).',
        errorCapital: 'حجم رأس مال الشركة مطلوب.',
        errorSeniority: 'المستوى الوظيفي مطلوب.',
        errorLoad: 'فشل تحميل الملف الشخصي.',
        errorComplete: 'فشل إكمال الملف الشخصي.',
      },
      registrationSteps: {
        yourProgress: 'تقدمك',
        inProgress: 'قيد التنفيذ',
        completed: 'مكتمل',
        backStep: 'رجوع',
        step1: 'الملف الشخصي',
        step2: 'تفاصيل السفر',
        step3: 'الفندق',
        step4: 'خطاب التأشيرة',
      },
      travelDetails: {
        title: 'تفاصيل السفر',
        subtitle: 'أخبرنا عن خطط سفرك للمنتدى.',
        flightIssued: 'تم إصدار التذكرة',
        flightNumber: 'رقم الرحلة',
        arrivalDate: 'تاريخ الوصول',
        arrivalTime: 'وقت الوصول',
        departureDate: 'تاريخ المغادرة',
        departureTime: 'وقت المغادرة',
        yes: 'نعم',
        no: 'لا',
        save: 'حفظ ومتابعة',
        saving: 'جاري الحفظ...',
      },
      hotel: {
        title: 'الإقامة الفندقية',
        subtitle: 'اختر أو أكد إقامتك الفندقية للمنتدى.',
        hotelAssigned: 'الفندق',
        hotelName: 'اسم الفندق',
        checkIn: 'تاريخ الوصول',
        checkOut: 'تاريخ المغادرة',
        roomType: 'نوع الغرفة',
        save: 'حفظ ومتابعة',
        saving: 'جاري الحفظ...',
      },
      visaLetter: {
        title: 'خطاب التأشيرة',
        subtitle: 'اطلب خطاب دعوة لطلب التأشيرة.',
        note: 'ملاحظة: الدول التالية تحتاج خطاب تأشيرة — باكستان، بنغلاديش، سريلانكا، نيبال، نيجيريا، إثيوبيا، الصومال، اليمن، السودان.',
        visaLetterRequired: 'خطاب التأشيرة مطلوب',
        visaLetterIssued: 'تم إصدار خطاب التأشيرة',
        fullName: 'الاسم الكامل (كما في جواز السفر)',
        passportNumber: 'رقم جواز السفر',
        nationality: 'الجنسية',
        requestLetter: 'طلب الخطاب',
        requested: 'تم طلب الخطاب',
        saving: 'جاري الحفظ...',
      },
      seatAllocation: {
        title: 'تخصيص المقاعد',
        subtitle: 'خريطة مقاعد على طراز المسرح مع ألوان حسب الفئة. عيّن الفئات واقفل المقاعد.',
        seatingMap: 'خريطة المقاعد',
        seatingPlans: 'خطط المقاعد',
        stage: 'المنصة',
        stageLong: 'المنصة — القاعة الرئيسية',
        legend: 'الدليل – اختر فئة ثم انقر على المقعد للتخصيص',
        clickToAssign: 'انقر على مقعد لتعيين الفئة المختارة.',
        shiftClickToLock: 'Shift+انقر لقفل المقعد أو فتحه.',
        exportPdf: 'تصدير PDF',
        addPlan: 'إضافة خطة مقاعد',
        loadingPlans: 'جارٍ تحميل خطط المقاعد...',
        saving: 'جارٍ الحفظ...',
        saveChanges: 'حفظ التغييرات',
        saved: 'تم الحفظ',
        duplicate: 'نسخ',
        emptyTitle: 'لا توجد خطط مقاعد بعد',
        emptySubtitle: 'أنشئ أول خطة مقاعد لبدء تصميم تخطيط القاعة بتشكيلات مخصصة.',
        createFirstPlan: 'إنشاء أول خطة',
        doneEditing: 'إنهاء التعديل',
        editLayout: 'تعديل التخطيط',
        add: 'إضافة',
        removePlan: 'إزالة الخطة',
        confirmRemovePlanTitle: 'إزالة خطة المقاعد؟',
        confirmRemovePlanMessage: 'سيتم حذف خطة المقاعد "{name}" نهائياً. لا يمكن التراجع عن هذا الإجراء.',
        cancel: 'إلغاء',
        remove: 'إزالة',
        planNamePlaceholder: 'مثال: اليوم 3 أو البرنامج 2',
        planLabel: 'الخطة {number}',
        planName: 'اسم الخطة',
        rows: 'الصفوف',
        seatsPerRow: 'مقاعد لكل صف',
        locked: 'مقفول',
        toolbar: {
          rows: 'الصفوف',
          cols: 'الأعمدة',
          aisles: 'الممرات',
          doors: 'الأبواب',
          addRowTop: 'إضافة صف في الأعلى',
          removeRowTop: 'إزالة صف من الأعلى',
          addRowBottom: 'إضافة صف في الأسفل',
          removeRowBottom: 'إزالة صف من الأسفل',
          addColLeft: 'إضافة عمود يساراً',
          removeColLeft: 'إزالة عمود من اليسار',
          addColRight: 'إضافة عمود يميناً',
          removeColRight: 'إزالة عمود من اليمين',
          insertV: 'إدراج ممر عمودي',
          insertH: 'إدراج ممر أفقي',
          eraserHelp: 'انقر على أي مقعد لإزالته. وانقر على خلية فارغة لإضافة مقعد مرة أخرى.',
        },
        statistics: 'الإحصائيات',
        stats: {
          total: 'الإجمالي',
          locked: 'المقفولة',
          assigned: 'المعيّنة',
        },
        eraser: 'الممحاة',
        on: 'تشغيل',
        aisle: 'ممر',
        tooltips: {
          removeAisle: 'إزالة الممر',
          insertVerticalAisle: 'إدراج ممر عمودي',
          addSeatLeft: 'إضافة مقعد يساراً',
          removeSeatLeft: 'إزالة مقعد من اليسار',
          addSeatRight: 'إضافة مقعد يميناً',
          removeSeatRight: 'إزالة مقعد من اليمين',
          clickToAddSeat: 'انقر لإضافة مقعد',
          addTopSeat: 'إضافة مقعد علوي',
          removeTopSeat: 'إزالة المقعد العلوي',
          addBottomSeat: 'إضافة مقعد سفلي',
          removeBottomSeat: 'إزالة المقعد السفلي',
        },
        vip: 'كبار الشخصيات',
        government: 'كبار الشخصيات الحكومية',
        omanGovernment: 'حكومة عُمان',
        investor: 'مستثمر',
        speaker: 'متحدث',
        general: 'عام',
        media: 'إعلام',
        addRow: 'إضافة صف',
        removeRow: 'إزالة صف',
        addColumn: 'إضافة عمود',
        removeColumn: 'إزالة عمود',
        rowsCols: 'صفوف × أعمدة',
        doors: 'مداخل ومخارج',
        doorsHelp: 'أضف مداخل ومخارج على خريطة المقاعد. تظهر على الحواف.',
        addEntrance: 'إضافة مدخل',
        addExit: 'إضافة مخرج',
        entrance: 'مدخل',
        exit: 'مخرج',
        doorSide: 'الجانب',
        doorPosition: 'الموقع',
        doorAlignment: 'المحاذاة',
        alignmentLeft: 'يسار',
        alignmentCenter: 'وسط',
        alignmentRight: 'يمين',
        doorLabel: 'التسمية (اختياري)',
        doorLabelPlaceholder: 'مثال: رئيسي، جانبي ١',
        sideTop: 'أعلى',
        sideBottom: 'أسفل',
        sideLeft: 'يسار',
        sideRight: 'يمين',
        removeDoor: 'إزالة الباب',
        noDoorsYet: 'لم تتم إضافة أبواب. أضف مداخل أو مخارج أعلاه.',
        assignedToLabel: 'معيّن لـ',
        assignToLabel: 'تعيين إلى (الاسم أو البريد)',
        assignToPlaceholder: 'مثال: الاسم أو البريد',
        lockSeat: 'قفل المقعد',
        unlockSeat: 'فتح القفل',
        selectedSeat: 'المقعد المحدد',
        assignedSeatsList: 'المقاعد المعيّنة',
        nameHeader: 'الاسم',
        seatNumber: 'المقعد',
      },
      announcements: {
        title: 'الإعلانات',
        subtitle:
          'أنشئ وأرسل التحديثات الهامة وتغييرات الجدول والتعليمات اللوجستية لجميع مستخدمي التطبيق.',
        headerSubtitle: 'إدارة الرسائل عبر قناتين منفصلتين للتنبيهات داخل التطبيق وحملات البريد الإلكتروني.',
        cardDescription:
          'إنشاء وإدارة الإعلانات التي تظهر مباشرة داخل تطبيق Advantage Oman.',
        searchLabel: 'البحث في الإعلانات',
        searchPlaceholder: 'ابحث بالعنوان أو المحتوى…',
        searchAppPlaceholder: 'البحث في إعلانات التطبيق…',
        searchEmailPlaceholder: 'البحث في إعلانات البريد…',
        statusLabel: 'الحالة',
        categoryLabel: 'الفئة',
        labelLabel: 'التصنيف',
        newAnnouncement: 'إعلان جديد',
        formTitle: 'إنشاء إعلان',
        titleLabel: 'العنوان',
        titlePlaceholder: 'اكتب عنواناً واضحاً ومختصراً…',
        messageLabel: 'الرسالة',
        messagePlaceholder:
          'اكتب نص الإعلان كما سيظهر داخل التطبيق. اجعله قصيراً ومباشراً.',
        categoryPlaceholder: 'مثال: عام، لوجستي، البرنامج',
        statusPublished: 'منشور',
        statusScheduled: 'مجدول',
        statusDraft: 'مسودة',
        sendPushLabel: 'إرسال إشعار دفع',
        sendPushHelp:
          'في حال التفعيل، قد يتلقى الحضور الذين ثبّتوا التطبيق إشعاراً عند نشر هذا الإعلان.',
        scheduleLabel: 'الجدولة لوقت لاحق',
        scheduleHelp: 'اختياري. اتركه فارغاً للإرسال فوراً.',
        createButton: 'إرسال الإعلان',
        creatingButton: 'جاري الإرسال…',
        createdSuccess: 'تم إرسال الإعلان بنجاح.',
        createdError: 'فشل في إرسال الإعلان.',
        noAnnouncementsTitle: 'لا توجد إعلانات بعد.',
        noAnnouncementsBody:
          'عند بدء إرسال التحديثات، ستظهر هنا في موجز زمني منظم وواضح.',
        rolesLabel: 'من يجب أن يرى هذا؟',
        alertDescription: 'إرسال تنبيه داخل التطبيق للدور المحددة.',
        detailTitle: 'تفاصيل الإعلان',
        targetAudience: 'الجمهور المستهدف',
        sentTo: 'أُرسل إلى',
        recipientsWord: 'مستلمين',
        allLabels: 'جميع التصنيفات',
        noLabel: 'بدون تصنيف',
        additionalEmails: 'عناوين بريد إلكتروني إضافية (غير مسجلين)',
        additionalEmailsHint: 'أدخل بريداً أو أكثر مفصولة بفاصلة أو سطر جديد.',
        channelEmail: 'بريد إلكتروني',
        channelApp: 'تطبيق',
        untitled: 'إعلان بدون عنوان',
        statTotal: 'الإجمالي',
        appColumnTitle: 'إعلانات التطبيق',
        appColumnSubtitle: 'إشعارات وتنبيهات داخل التطبيق',
        emailColumnTitle: 'إعلانات البريد الإلكتروني',
        emailColumnSubtitle: 'رسائل إخبارية عبر البريد الإلكتروني',
        newApp: 'إعلان تطبيق',
        newEmail: 'إعلان بريد',
        noAppAnnouncements: 'لا توجد إعلانات تطبيق',
        noEmailAnnouncements: 'لا توجد إعلانات بريد',
        createFirst: 'أنشئ أول إعلان باستخدام الزر أعلاه.',
        item: 'عنصر',
        items: 'عناصر',
        createEmailTitle: 'إنشاء إعلان بريد إلكتروني',
        createAppTitle: 'إنشاء إعلان تطبيق',
        createEmailDesc: 'اكتب وأرسل عبر البريد الإلكتروني إلى المستلمين المحددين.',
        createAppDesc: 'أرسل تنبيهاً داخل التطبيق لمجموعات المستخدمين المحددة.',
        titleMessageRequired: 'العنوان والرسالة مطلوبان',
        selectRoleApp: 'يرجى اختيار دور واحد على الأقل لإعلانات التطبيق.',
        selectRoleOrEmail: 'اختر دوراً واحداً على الأقل أو أضف بريداً إلكترونياً خارجياً واحداً على الأقل.',
        emailSentSuccess: 'تم إرسال إعلان البريد الإلكتروني بنجاح.',
        appSentSuccess: 'تم إنشاء إعلان التطبيق بنجاح.',
        feedUnavailable: 'خدمة الإعلانات غير متاحة حالياً. لا يزال بإمكانك إنشاء إعلانات جديدة.',
        registeredUsers: 'مستخدمون مسجلون',
        notRegistered: 'غير مسجلين (خارجي)',
        registeredShort: 'مسجّل',
        notRegisteredShort: 'غير مسجّل',
        labelUpdate: 'تحديث',
        labelUrgent: 'عاجل',
        labelReminder: 'تذكير',
        labelLogistics: 'لوجستيات',
        labelSchedule: 'تغيير الجدول',
        labelWelcome: 'ترحيب',
        labelNetworking: 'تواصل',
        labelGeneral: 'معلومات عامة',
        paginationPrev: 'السابق',
        paginationNext: 'التالي',
        paginationSummary: '{start}–{end} من {total}',
      },
      export: {
        title: 'التصدير',
        description: 'تصدير الضيوف والبرامج والجدول والحضور واللوجستيات والمدفوعات وغيرها إلى Excel أو PDF.',
        cardDescription: 'تصدير الضيوف والبرامج والجدول والحضور واللوجستيات والمدفوعات وغيرها إلى Excel أو PDF.',
        fullGuests: 'القائمة الكاملة للضيوف',
        fullGuestsDesc: 'جميع الضيوف المسجلين مع التفاصيل.',
        programs: 'البرامج',
        programsDesc: 'قائمة برامج المنتدى.',
        schedule: 'الجدول',
        scheduleDesc: 'جدول الفعالية.',
        sponsors: 'الرعاة',
        sponsorsDesc: 'قائمة الرعاة.',
        speakers: 'المتحدثون',
        speakersDesc: 'قائمة المتحدثين.',
        attendance: 'الحضور',
        attendanceDesc: 'قائمة الحضور مع معلومات الوصول.',
        seatAllocation: 'توزيع المقاعد',
        seatAllocationDesc: 'تصدير خطة المقاعد كـ PDF (نفس صفحة توزيع المقاعد).',
        selectSeatPlan: 'اختر خطة المقاعد',
        fromDate: 'من تاريخ',
        interestedApplications: 'طلبات الاهتمام',
        interestedApplicationsDesc: 'الطلبات مع التفاصيل الكاملة.',
        applicationsLabel: 'الطلبات',
        logisticsRecords: 'السجلات',
        visaLettersGuests: 'الضيوف',
        pdfGeneratedFrom: 'مُنشأ من لوحة تحكم أدفانتج عُمان',
        logistics: 'اللوجستيات',
        logisticsDesc: 'تفاصيل السفر والفندق والتأشيرة والاستلام.',
        airportArrivals: 'وصول المطار فقط',
        airportArrivalsDesc: 'حسب تاريخ ووقت الوصول. اختر من تاريخ للتصفية.',
        paymentRecords: 'سجلات الدفع',
        paymentRecordsDesc: 'جميع سجلات الدفع من صفحة المدفوعات.',
        visaLettersRequired: 'خطابات التأشيرة المطلوبة',
        visaLettersRequiredDesc: 'الضيوف الذين طلبوا خطاب تأشيرة (تفاصيل السفر).',
        guestsByCategory: 'الضيوف حسب الفئة',
        guestsByCategoryDesc: 'تصدير الضيوف حسب الدور (مثل الإعلام، المتحدث، الراعي). اختر فئة أو أكثر.',
        buttons: {
          excel: 'Excel',
          pdf: 'PDF',
          exportPdf: 'تصدير PDF',
        },
        labels: {
          fullName: 'الاسم الكامل',
          email: 'البريد الإلكتروني',
          username: 'اسم المستخدم',
          organization: 'الشركة',
          position: 'المنصب',
          role: 'الدور',
          country: 'الدولة',
          sector: 'القطاع',
          vip: 'كبار الشخصيات',
          investor: 'مستثمر',
        },
        errors: {
          exportFailed: 'فشل التصدير',
        },
      },
      driverPickup: {
        title: 'استلام السائقين',
        subtitle: 'تعيين السائقين بسرعة عبر السحب والإفلات أو التعيين بنقرة واحدة.',
        export: 'تصدير',
        guests: 'الضيوف',
        assigned: 'المعيّن',
        unassigned: 'غير المعيّن',
        drivers: 'السائقون',
        loadingData: 'جارٍ تحميل بيانات الاستلام...',
        guestsArrival: 'الضيوف (الوصول)',
        searchGuestsPlaceholder: 'ابحث عن الضيوف بالاسم أو البريد أو رقم الرحلة...',
        allAssignments: 'كل التعيينات',
        assignedOnly: 'المعيّن فقط',
        unassignedOnly: 'غير المعيّن فقط',
        noGuestsMatch: 'لا يوجد ضيوف يطابقون عوامل التصفية الحالية.',
        assignedStatus: 'مُعيَّن',
        pendingStatus: 'بانتظار التعيين',
        assignments: 'عدد التعيينات',
        arrivalDate: 'تاريخ الوصول',
        arrivalTime: 'وقت الوصول',
        flightNumber: 'رقم الرحلة',
        dragHint: 'اسحب بطاقة سائق هنا، أو استخدم التعيين السريع.',
        quickAssign: 'تعيين سريع لسائق',
        assign: 'تعيين',
        clear: 'إزالة',
        addDriver: 'إضافة سائق',
        searchDriversPlaceholder: 'ابحث عن السائقين...',
        noDriversFound: 'لا يوجد سائقون.',
        dragCardHint: 'اسحب هذه البطاقة إلى ضيف',
        viewWorkload: 'عرض عبء العمل',
        removeDriver: 'حذف السائق',
        addNewDriver: 'إضافة سائق جديد',
        driverNamePlaceholder: 'اسم السائق',
        driverContactPlaceholder: 'رقم تواصل السائق',
        saveDriver: 'حفظ السائق',
        driverWorkload: 'عبء عمل السائق',
        noGuestsAssignedToDriver: 'لا يوجد ضيوف معيّنون لهذا السائق.',
        arrival: 'الوصول',
        exportDriverPickup: 'تصدير استلام السائقين',
        whatToExport: 'ماذا تريد تصديره',
        allGuests: 'كل الضيوف',
        assignedGuestsOnly: 'الضيوف المعيّنون فقط',
        exactArrivalDate: 'تاريخ وصول محدد',
        specificDriverWorkload: 'عبء عمل سائق محدد',
        selectDate: 'اختر التاريخ',
        selectDriver: 'اختر السائق',
        selectADriver: 'اختر سائقاً',
        exportExcel: 'تصدير Excel',
        exportPdf: 'تصدير PDF',
        confirmClearAssignment: 'هل تريد إزالة تعيين الاستلام لهذا الضيف؟',
        failedClearAssignment: 'فشل في إزالة التعيين.',
        enterDriverDetails: 'يرجى إدخال اسم السائق وبيانات التواصل.',
        driverExists: 'هذا السائق موجود بالفعل.',
        confirmRemoveDriver: 'هل تريد حذف هذا السائق؟ ستبقى تعيينات الضيوف الحالية حتى يتم تعديلها يدوياً.',
        exportFailed: 'فشل التصدير.',
        pdfTitle: 'تصدير استلام السائقين',
        pdfFooter: 'تقرير استلام السائقين',
        brand: 'أدفانتج عُمان',
        generated: 'تم الإنشاء',
        role: 'الدور',
        driver: 'السائق',
        driverPhone: 'هاتف السائق',
        status: 'الحالة',
        driverWorkloadExport: 'تصدير عبء عمل السائق',
      },
    },
  },
};

